import { Injectable, Input, ViewChild } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { take, concat } from 'rxjs/operators';
import { merge } from 'rxjs/observable/merge';
import { Spot } from '../models/Item';
import { Chart } from 'chart.js';
import { User, Client } from '../core/user';
import * as _ from 'lodash';


import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { AuthService } from '../core/auth.service';
import { Router, ActivatedRoute } from '@angular/router';



@Injectable()
export class ItemService {


  showSpinner: boolean = true;

  spotsCollection: AngularFirestoreCollection<Spot>;
  spots: Observable<Spot[]>;
  newSpots: Observable<Spot[]>;
  spotDoc: AngularFirestoreDocument<Spot>;
  data: any;
  dateRange: any[];
  dateSelected: any;
  bsRangeValue: any = [];
  sd: any;
  ed: any;
  startDate: any;
  endDate: any;
  // selected_adv: any;
  url: any;
  newSpotsData: any;
  dataAvailable: any;



  subscription: Subscription;

  // Main Dashboard Variables
  seasonality_spend: any;
  seasonality_minutes: any;
  seasonality_count: any;
  seasonality_days: any;
  seasonality_avgSpend: any;
  total_spend: any;
  total_minutes: any;
  total_count: any;
  averageSpendPerDay: any;
  maxSpend_value: any;
  maxSpend_day: any;
  minSpend_value: any;
  minSpend_day: any;
  top_channels: any;
  top_brands: any;
  top_slots: any;
  top_categories: any;
  top_companies: any;
  slots_name: any;
  slots_value: any;
  aggregated_brands: any;
  aggregated_channels: any;
  aggregated_slots: any;
  aggregated_days: any;
  aggregated_categories: any;
  aggregated_dataByBrands: any;
  aggregated_dataByChannels: any;
  aggregated_dataBySlots: any;
  // last_selected_adv: any;
  dataNew: any;
  doMore: boolean = true;
  dataSource_adv_brands_tab: any;
  selected_adv_brand: any;
  selected_adv_channel: any;


  // Advertisers - Brands Page

  topBrand_Single: any;
  lastBrand_Single: any;
  averageSpendByBrands: any;
  topBrandSOS: any;
  lastBrandSOS: any;
  alertMessage: any;
  countsExtended: any;
  selected_adv_sos: any;
  selected_adv_som: any;
  selected_adv_sof: any;
  selected_adv_brandNames: any;
  dataSource_adv_brands_days_tab: any;
  dataSource_adv_channel_tab: any;

  // Categories - Dashboard Page
  selected_cat: any;
  aggregated_sub_categories: any;
  aggregated_companies: any;
  channels_name: any;
  channels_value: any;

  // Slots - Adv Sec

  selected_adv_slot: any;
  list_slots_adv: any;
  grouped_Slots: any;
  slots_ByBrandchart: any;
  groupedSlots: any;

  slot_chart_brandName_arr: any;
  slot_chart_morning_arr: any;
  slot_chart_matinee_arr: any;
  slot_chart_prePrime_arr: any;
  slot_chart_prime_arr: any;
  slot_chart_postPrime_arr: any;
  slot_chart_lateNight_arr: any;

  topSlot_Single: any;
  lastSlot_Single: any;
  averageSpendBySlots: any;
  topSlotSOS: any;
  lastSlotSOS: any;

  // Positions

  aggregated_positions: any;
  aggregated_dataByPositions: any;
  list_positions_adv: any;
  selected_adv_position: any;
  topPosition_Single: any;
  averageSpendByPositions: any;
  lastPosition_Single: any;
  topPositionSOS: any;
  lastPositionSOS: any;
  selected_advDataByPositions: any;
  positions_ByBrandchart: any;

  position_chart_brandName_arr: any;
  position_chart_first_arr: any;
  position_chart_second_arr: any;
  position_chart_regular_arr: any;
  position_chart_secondLast_arr: any;
  position_chart_last_arr: any;
  position_chart_island_arr: any;
  grouped_Positions_ByBrand: any;
  groupedPositions_ByBrand: any;
  grouped_Positions_ByCompany: any;
  groupedPositions_ByCompany: any;
  grouped_Positions: any;
  groupedPositions: any;

  regularSpotSpend: any;
  premiumSpotSpend: any;
  premiumVsRegular_arr: any;

  positions_RegularVsPremium: any;

  // Charts

  seasonality_trend_chart: any;
  total_spend_chart: any;
  total_minutes_chart: any;
  total_count_chart: any;
  top_slots_chart: any;
  channels_chart: any;
  brand_numbers: any;
  list_brandby_adv: any;
  list_channelby_adv: any;
  dataSource_categoryToCompare_Bychannels: any;
  aggregated_categoryToCompare_Bychannels_spend: any;
  aggregated_categoryToCompare_Bychannels_minutes: any;
  aggregated_categoryToCompare_Bychannels_frequency: any;


  ///////////// new structure /////////

  // selected_adv = 'PROCTER & GAMBLE PAKISTAN';
  selected_adv: any;
  selected_adv_categories: any[];
  compare_category_array: any[];
  selected_toCompare_category: any;
  aggregated_categoryToCompare_Bydays: any;
  aggregated_categoryToCompare_Bybrands: any;
  aggregated_categoryToCompare_Bycategories: any;
  aggregated_categoryToCompare_Bychannels: any;
  aggregated_categoryToCompare_Byslots: any;
  compare_brand_array: any;
  selected_toCompare_brand: any;
  dataSource_brandToCompare_Bychannels: any;

  aggregated_brandToCompare_Bydays: any;
  aggregated_brandToCompare_Bybrands: any;
  aggregated_brandToCompare_Bycategories: any;
  aggregated_brandToCompare_Bychannels: any;
  aggregated_brandToCompare_Byslots: any;
  selected_advData: any;
  remeberAdv: any;

  //// Positions Page

  selected_metric: any;
  selected_adv_positionsForChart: any
  genre_ByCategoryChart: any

  selected_adv_positionsForChart_regular: any;
  selected_adv_positionsForChart_first: any;
  selected_adv_positionsForChart_second: any;
  selected_adv_positionsForChart_last: any;
  selected_adv_positionsForChart_secondLast: any;
  selected_adv_positionsForChart_island: any;
  positions_ByCompanyChart: any;
  position_ByCompanySpend: any;
  position_ByCompanyName: any;
  position_ByCompanyMinutes: any;
  position_ByCompanyCount: any;
  grouped_Positions_ByCategory: any;
  groupedPositions_ByCategory: any

  position_ByCategorySpend: any;
  position_ByCategoryName: any;
  position_ByCategoryMinutes: any;
  position_ByCategoryCount: any;
  positions_ByCategoryChart: any;


  //// //// Slots Pages //////

  grouped_Slots_ByCompany: any;
  groupedSlots_ByCompany: any;

  slot_ByCompanySpend: any;
  slot_ByCompanyName: any;
  slot_ByCompanyMinutes: any;
  slot_ByCompanyCount: any;

  groupedSlots_ByCategory: any;
  grouped_Slots_ByCategory: any;

  slot_ByCategorySpend: any;
  slot_ByCategoryName: any;
  slot_ByCategoryMinutes: any;
  slot_ByCategoryCount: any;


  aggregated_dataByBrands_Complete: any;
  aggregated_dataByChannels_Complete: any;
  aggregated_dataBySlots_Complete: any;
  aggregated_dataByPositions_Complete: any;
  slots_ByCategoryChart: any;
  top_slots_chartforSlot: any;
  slots_ByCompanyChart: any;
  genre_ByCompanyChart: any;
  region_ByCompanyChart: any;
  /// Genre Chart

  aggregated_genre: any;
  genreWiseData_Spend: any;
  genreWiseData_Names: any;
  regionWiseData_Spend: any;
  regionWiseData_Names: any;
  aggregated_region: any;
  regionWiseData_SOS: any;
  genreWiseData_SOS: any;
  slots_sos: any;
  secondary_slots_sos: any;

  /////// Brands Compare

  secondary_selected_adv: any;
  secondary_selected_adv_position: any;
  secondary_selected_adv_brand: any;
  secondary_selected_adv_channel: any;
  secondary_list_slots_adv: any;
  secondary_list_positions_adv: any;
  secondary_aggregated_days: any;
  secondary_aggregated_brands: any;
  secondary_aggregated_categories: any;
  secondary_aggregated_channels: any;
  secondary_aggregated_slots: any;
  secondary_list_brandby_adv: any;
  secondary_list_channelby_adv: any;
  secondary_aggregated_positions: any;
  secondary_countsExtended: any;
  secondary_total_spend: any;
  secondary_total_minutes: any;
  secondary_total_count: any;
  secondary_seasonality_spend: any;
  secondary_seasonality_minutes: any;
  secondary_seasonality_count: any;
  secondary_seasonality_days: any;
  secondary_averageSpendPerDay: any;
  secondary_seasonality_avgSpend: any;
  secondary_minSpend_value: any;
  secondary_maxSpend_value: any;
  secondary_maxSpend_day: any;
  secondary_minSpend_day: any;

  secondary_topBrand_Single: any;
  secondary_lastBrand_Single: any;
  secondary_topBrandSOS: any;
  secondary_lastBrandSOS: any;
  secondary_slots_name: any;
  secondary_slots_value: any;
  secondary_averageSpendByBrands: any;
  secondary_selected_adv_sos: any;
  secondary_selected_adv_som: any;
  secondary_selected_adv_sof: any;
  secondary_selected_adv_brandNames: any;
  secondary_dataSource_adv_brands_tab: any;
  secondary_dataSource_adv_brands_days_tab: any;
  secondary_dataSource_adv_channel_tab: any;
  secondary_regionWiseData_Spend: any;
  secondary_regionWiseData_Names: any;
  secondary_regionWiseData_SOS: any;
  secondary_aggregated_region: any;
  secondary_genreWiseData_Spend: any;
  secondary_genreWiseData_Names: any;
  secondary_genreWiseData_SOS: any;
  secondary_aggregated_genre: any;
  secondary_position_ByCompanyName: any;
  secondary_position_ByCompanySpend: any;
  secondary_position_ByCompanyMinutes: any;
  secondary_position_ByCompanyCount: any;

  /// Category Page /////

  industry_total_spend: any;
  industry_total_minutes: any;
  industry_total_count: any;
  industry_seasonality_spend: any;
  industry_seasonality_minutes: any;
  industry_seasonality_count: any;
  industry_seasonality_days: any;


  /// publisher Categories
  categoryTotalSpend: any;
  aggregated_positions_cat: any;
  positionMix_Chart: any;
  genreMix_Chart: any
  channelTpye_Chart: any
  positions_cat_values: any;
  positions_cat_names: any;
  positions_cat_sos: any;
  genre_cat_values: any;
  genre_cat_names: any;
  genre_cat_sos: any;
  aggregated_channelType: any;
  channelType_cat_values: any;
  channelType_cat_names: any;
  channelType_cat_sos: any;
  aggregated_categoryToCompare_Bygenre: any;
  userCategories: any;


  // User Auth //

  userCollection: any;
  users: Observable<User[]>;
  userDocs: any;
  userData: any;

  clientCollection: any;
  clients: Observable<Client[]>;
  clientDocs: any;
  clientData: any;
  startDateTemp: any;
  endDateTemp: any;

  //// Industry ////
  industryData: any;
  industryCollection: AngularFirestoreCollection<Spot>;
  industry: Observable<Spot[]>;
  industryDocs: any;
  industryCompareData: any;
  aggregated_daysIndustry: any;
  differenceSpend: any;
  differenceMinutes: any;
  differenceCount: any;

  dailySpotsCollection: any;
  logsCollection: AngularFirestoreCollection<any>;
  events: Observable<Spot[]>;
  days: number;
  credits: number;
  remainingQuota: number;
  remainingCredits: number;
  creditsUsage: any;
  creditsUsageCollection: AngularFirestoreCollection<any>;

  // User Activity
  today: any;
  past7days: any;
  eventsData: any;
  aggregatedLogs: Observable<Spot[]>;
  agg_logs: any;
  total_logins: any;
  total_pageViews: any;
  total_dataRequests: any;
  total_dateChanges: any;
  total_logouts: any;
  total_advertiserChanges: any;
  total_brandChanges: any;
  total_secAdvertiserChanges: any;
  total_secBrandChanges: any;
  total_compareClicks: any;
  dailyActivity: any;
  weeklyActivity: any;
  monthlyActivity: any;
  userActivityData: any;

  // Publishers

  publishersCollection: AngularFirestoreCollection<Spot>;
  pubs: Observable<Spot[]>;
  publishersData: any;
  publishers: any;
  primaryAdvertisers: any;
  selected_primaryChannel: any;
  selected_secondaryChannel: any;
  secondaryAdvertisers: any;
  missingAdvertisers_sec: any;
  publishersData_primary: any;
  publishersData_competitionOne: any;
  publishersData_competitionTwo: any;
  publishersData_competitionThree: any;
  publishersData_competitionFour: any;
  missingAdvertisers_ComOne: any;
  missingAdvertisers_ComTwo: any;
  missingAdvertisers_ComThree: any;
  missingAdvertisers_ComFour: any;
  selected_CompOne: any;
  selected_CompTwo: any;
  selected_CompThree: any;
  selected_CompFour: any;
  secondaryAdvertisersOne: any
  secondaryAdvertisersTwo: any
  secondaryAdvertisersThree: any
  secondaryAdvertisersFour: any
  Top20Advertisers_One: any;
  Top20Advertisers_Two: any;
  Top20Advertisers_Three: any;
  Top20Advertisers_Four: any;
  fetchPulisher: any;
  fetchPulisherType: any;
  channelTimeband_One: any;
  channelTimeband_Two: any;
  channelTimeband_Three: any;
  channelTimeband_Four: any;
  channelTimeband_One_ready: boolean = false;
  channelTimeband_Two_ready: boolean = false;
  channelTimeband_Three_ready: boolean = false;
  channelTimeband_Four_ready: boolean = false;

  sortedByDay_Sun0: any;
  sortedByDay_Mon1: any;
  sortedByDay_Tue2: any;
  sortedByDay_Wed3: any;
  sortedByDay_Thu4: any;
  sortedByDay_Fri5: any;
  sortedByDay_Sat6: any;

  dayArray_Sun0: any;
  dayArray_Mon1: any;
  dayArray_Tue2: any;
  dayArray_Wed3: any;
  dayArray_Thu4: any;
  dayArray_Fri5: any;
  dayArray_Sat6: any;



  constructor(public afs: AngularFirestore, private authService: AuthService, private router: Router, private route: ActivatedRoute) {

  }

  logsAggregation() {
    this.logsCollection = this.afs.collection('aggregations');
    // this.events = this.logsCollection.valueChanges().pipe(take(1));

    this.logsCollection.valueChanges().subscribe(res => {
      res.forEach(p => {
        if (p.dailyActivity) this.dailyActivity = p;
        if (p.weeklyActivity) this.weeklyActivity = p;
        if (p.monthlyActivity) this.monthlyActivity = p;
      })
      this.userActivityData = this.dailyActivity;
    })
    return this.aggregatedLogs;
  }


  userActivity() {

    var days = 7;
    var today = new Date();
    var d = new Date();
    var last = new Date(new Date().setDate(new Date().getDate() - days));


    const industryData = new Array();

    this.logsCollection = this.afs.collection('eventLogs', ref => ref.orderBy('timestamp', 'asc')
      .where('timestamp', '>=', last).where('timestamp', '<=', today));
    // this.events = this.logsCollection.valueChanges().pipe(take(1));
    this.logsCollection.valueChanges().subscribe(res => {
      this.eventsData = res;
      this.userActivityDashboard();
    })
    return this.events;
  }


  userActivityDashboard() {
    let sumLogins;
    let sumPageViews;
    let sumDataRequests;
    let sumDateChanged;
    let sumLogouts;
    let sumAdvertiserChanged;
    let sumBrandChanged;
    let sumSecAdvertiserChanged;
    let sumSecBrandChanged;
    let sumCompareClicked;
    sumLogins = 0;
    sumPageViews = 0
    sumDataRequests = 0;
    sumDateChanged = 0;
    sumLogouts = 0;
    sumAdvertiserChanged = 0;
    sumBrandChanged = 0;
    sumSecAdvertiserChanged = 0;
    sumSecBrandChanged = 0;
    sumCompareClicked = 0;

    this.eventsData.forEach(p => {
      if (p.event_type === 'onLogin') sumLogins++;
      if (p.event_type === 'onPageView') sumPageViews++;
      if (p.event_type === 'onDateChange' || p.event_type === 'onLogin') sumDataRequests++;
      if (p.event_type === 'onDateChange') sumDateChanged++;
      if (p.event_type === 'onLogout') sumLogouts++;
      if (p.event_type === 'onAdvertiserChange') sumAdvertiserChanged++;
      if (p.event_type === 'onBrandChange') sumBrandChanged++;
      if (p.event_type === 'onSecondaryAdvertiserChange') sumSecAdvertiserChanged++;
      if (p.event_type === 'onSecondaryBrandChange') sumSecBrandChanged++;
      if (p.event_type === 'onCompareClicked') sumCompareClicked++;
    });

    this.total_logins = sumLogins;
    this.total_pageViews = sumPageViews;
    this.total_dataRequests = sumDataRequests;
    this.total_dateChanges = sumDateChanged;
    this.total_logouts = sumLogouts;
    this.total_advertiserChanges = sumAdvertiserChanged;
    this.total_brandChanges = sumBrandChanged;
    this.total_secAdvertiserChanges = sumSecAdvertiserChanged;
    this.total_secBrandChanges = sumSecBrandChanged;
    this.total_compareClicks = sumCompareClicked;


  }

  logEvent(event_type: string, parameters: any) {
    // return `Event: ${event_type}, Parameters: ${JSON.stringify(parameters)}`;
    // Your Firebase Implementation here ...

    if (this.userData) {

      let eventData = null;
      eventData = {
        event_type: event_type,
        uid: this.authService.currentUserId,
        client: this.authService.loggedInUserClient,
        username: this.authService.currentUserName,
        timestamp: new Date(),
        parameters: parameters
      }


      // console.log(eventData)

      this.afs.collection<any>('eventLogs').add(eventData)
      // this.afs.collection<any>('Logs').add(eventData)

      eventData = null;

    } else {

      this.afs.collection('users').doc(this.authService.currentUserId).valueChanges().pipe(take(1)).subscribe(res => {
        this.userData = res;
        this.authService.loggedInUserName = this.userData.userName;
        this.authService.loggedInUserRole = this.userData.user_type;
        this.authService.loggedInUserClient = this.userData.client;

        let eventData = null;
        eventData = {
          event_type: event_type,
          uid: this.authService.currentUserId,
          client: this.authService.loggedInUserClient,
          username: this.authService.currentUserName,
          timestamp: new Date(),
          parameters: parameters
        }
        // console.log(eventData)

        this.afs.collection<any>('eventLogs').add(eventData)
        // this.afs.collection<any>('Logs').add(eventData)

        eventData = null;
      })
    }

  }


  getClientCategories() {
    this.clientCollection = this.afs.collection('clients', ref => ref.where('client_name', '==', this.authService.loggedInUserClient));

    this.clients = this.clientCollection.snapshotChanges().pipe(take(1)).map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as Client;
        data.client_id = a.payload.doc.id;
        return data;
      });
    });

    return this.clients;
  }

  defaultDate() {
    if (this.startDate) {
      this.sd = new Date(this.startDate);
      this.ed = new Date(this.endDate);
      this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    } else {
      this.sd = new Date('03-25-2018');
      this.ed = new Date('03-31-2018');
      this.days = Math.round(Math.abs((+(this.sd.getTime()) - +(this.ed.getTime())) / (24 * 60 * 60 * 1000))) + 1;

    }
  }

  getUser() {

    this.userCollection = this.afs.collection('users', ref => ref.where('uid', '==', this.authService.currentUserId));

    this.users = this.userCollection.snapshotChanges().pipe(take(1)).map(changes => {
      return changes.map(a => {
        const data = a.payload.doc.data() as User;
        data.uid = a.payload.doc.id;
        return data;
      });
    });

    // console.log(this.users);
    return this.users;
  }

  dateChangeDetector() {

    if (!this.authService.currentUser) {
      this.router.navigate(['/login']);
    }

    if (this.authService.currentUserId) {
      this.users = this.getUser();

      this.getUser().subscribe((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.userData = doc;

          const userCategories = new Array();

          this.clientDocs = this.getClientCategories();
          this.getClientCategories().subscribe((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.clientData = doc;
              this.clientData.categories.forEach(p => {
                userCategories.push(p.category)
              });
              this.userCategories = userCategories;
              this.checkQuota();
              // this.fetchData();
            });
          })
        });
      })

      return this.userCategories;


    }
  }

  checkQuota() {

    if (this.startDate) {
      this.sd = new Date(this.startDate);
      this.ed = new Date(this.endDate);
      this.days = Math.round(Math.abs((+(this.sd.getTime()) - +(this.ed.getTime())) / (24 * 60 * 60 * 1000))) + 1;

    } else {
      this.sd = new Date('03-25-2018');
      this.ed = new Date('03-31-2018');
      this.days = Math.round(Math.abs((+(this.sd.getTime()) - +(this.ed.getTime())) / (24 * 60 * 60 * 1000))) + 1;

    }

    this.credits = this.userCategories.length * this.days + this.days;
    this.remainingQuota = this.userData.monthly_quota - this.userData.used_quota;

    this.creditsUsage = {
      uid: this.userData.uid,
      userName: this.userData.userName,
      startDate: this.sd,
      endDate: this.ed,
      days: this.days,
      credits: this.credits,
      categories: this.userCategories.length,
      created: new Date()
    }

    if (this.credits + this.userData.used_quota <= this.userData.monthly_quota) {
      // When enough credits in monthly_quota
      if (this.url === '/publishers/missing-report' || this.url === '/publishers/top-advertisers' || this.url === '/publishers/competition-timeband' || this.url === '/publishers/weekly-chart') {
        this.fetchPublishers(this.fetchPulisher, this.fetchPulisherType);
      } else {
        this.fetchData();
      }
      // Add credits to used_quota
      const newUsed_quota = this.credits + this.userData.used_quota;
      this.userData.used_quota = newUsed_quota;
      var setDoc = this.afs.collection('users').doc(this.userData.uid).set(this.userData);

      // Credits Usage Log
      this.logsCollection = this.afs.collection<any>('creditsUsage');
      this.logsCollection.add(this.creditsUsage);

    } else if (this.credits <= (this.userData.topUpCredits + this.remainingQuota)) {
      // When no enough credits in monthly_quota use topUpCredits
      if (this.url === '/publishers/missing-report' || this.url === '/publishers/top-advertisers' || this.url === '/publishers/competition-timeband' || this.url === '/publishers/weekly-chart') {
        // this.fetchPublishers(value, type);
        this.fetchPublishers(this.fetchPulisher, this.fetchPulisherType);

      } else {
        this.fetchData();
      }
      // Minus credits from topUpCredits
      if (this.remainingQuota > 0) {
        this.userData.used_quota = this.userData.monthly_quota;
        this.remainingCredits = this.remainingQuota + this.userData.topUpCredits - this.credits
        this.userData.topUpCredits = this.remainingCredits;
        var setDoc = this.afs.collection('users').doc(this.userData.uid).set(this.userData);

        this.logsCollection = this.afs.collection<any>('creditsUsage');
        this.logsCollection.add(this.creditsUsage);

      } else {
        this.remainingCredits = this.userData.topUpCredits - this.credits
        this.userData.topUpCredits = this.remainingCredits;
        var setDoc = this.afs.collection('users').doc(this.userData.uid).set(this.userData);


        this.logsCollection = this.afs.collection<any>('creditsUsage');
        this.logsCollection.add(this.creditsUsage);
      }

    }
    else {
      // When no enough credits in bucket
      alert("Not enough credits");
    }




  }


  getIndustry() {

    if (this.startDate) {
      this.sd = new Date(this.startDate);
      this.ed = new Date(this.endDate);
      // this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));

    } else {
      this.sd = new Date('03-25-2018');
      this.ed = new Date('03-31-2018');
      // this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));

    }


    const industryData = new Array();

    this.industryCollection = this.afs.collection('industry', ref => ref.orderBy('date', 'asc')
      .where('date', '>=', this.sd).where('date', '<=', this.ed));
    this.industry = this.industryCollection.valueChanges().pipe(take(1));

    return this.industry;
  }

  getPublishers(value) {

    if (this.startDate) {
      this.sd = this.startDate
      this.ed = this.endDate;
      // this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));
    } else {
      this.sd = new Date('01-01-2017');
      this.ed = new Date('01-07-2017');
      // this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));
    }

    if (this.fetchPulisher) {
      this.publishersCollection = this.afs.collection('publishers', ref => ref.orderBy('date', 'asc')
        .where('date', '>=', this.sd).where('date', '<=', this.ed).where('channel', '==', value))
      this.publishers = this.publishersCollection.valueChanges().pipe(take(1));

      return this.publishers;
    }




  }

  fetchPublishers(value, type) {
    const pubsData = new Array();

    this.pubs = this.getPublishers(value);

    this.getPublishers(value).subscribe((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        pubsData.push(doc);
      })
      this.publishersData = pubsData;

      if (type === 'primary') {
        this.publishersData_primary = null;
        this.publishersData_primary = pubsData;
      }

      if (type === 'competitionOne') {
        this.publishersData_competitionOne = null;
        this.publishersData_competitionOne = pubsData;
      }
      if (type === 'competitionTwo') {
        this.publishersData_competitionTwo = null;
        this.publishersData_competitionTwo = pubsData;
      }
      if (type === 'competitionThree') {
        this.publishersData_competitionThree = null;
        this.publishersData_competitionThree = pubsData;
      }
      if (type === 'competitionFour') {
        this.publishersData_competitionFour = null;
        this.publishersData_competitionFour = pubsData;
      }

      if (this.url === '/publishers/missing-report') {
        this.missing_advertisers(type);
        this.showSpinner = false;
      }

      if (this.url === '/publishers/top-advertisers') {
        this.topAdv_publishers(value, type);
        this.showSpinner = false;
      }
      if (this.url === '/publishers/competition-timeband') {
        this.timeband_publishers(value, type);
        this.showSpinner = false;
      }

      if (this.url === '/publishers/weekly-chart') {
        this.weekly_chart(value, type);
        this.showSpinner = false;
      }



    })

  }

  missing_advertisers(type) {

    let primaryChannel = new Array()
    this.publishersData_primary.forEach(p => {
      p.tv.data.forEach(i => {
        primaryChannel.push(i.company)
      });
    });
    // Advertisers on Primary Channel
    this.primaryAdvertisers = primaryChannel
    // Sorting and Removing Duplicate Items
    this.primaryAdvertisers = Array.from(new Set(this.primaryAdvertisers.sort()));

    // Competition One

    if (type === 'competitionOne') {
      this.secondaryAdvertisersOne = new Array()
      let secondaryChannel_One = this.publishersData_competitionOne.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersOne.push(i.company)
        });
      });
      this.secondaryAdvertisersOne = Array.from(new Set(this.secondaryAdvertisersOne.sort()));
      this.missingAdvertisers_ComOne = this.secondaryAdvertisersOne.filter(function (n) { return !this.has(n) }, new Set(this.primaryAdvertisers))
    }

    // Competition Two
    if (type === 'competitionTwo') {
      this.secondaryAdvertisersTwo = new Array()
      let secondaryChannel_Two = this.publishersData_competitionTwo.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersTwo.push(i.company)
        });
      });
      this.secondaryAdvertisersTwo = Array.from(new Set(this.secondaryAdvertisersTwo.sort()));
      this.missingAdvertisers_ComTwo = this.secondaryAdvertisersTwo.filter(function (n) { return !this.has(n) }, new Set(this.primaryAdvertisers))
    }

    // Competition Three
    if (type === 'competitionThree') {
      this.secondaryAdvertisersThree = new Array()
      let secondaryChannel_Three = this.publishersData_competitionThree.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersThree.push(i.company)
        });
      });
      this.secondaryAdvertisersThree = Array.from(new Set(this.secondaryAdvertisersThree.sort()));
      this.missingAdvertisers_ComThree = this.secondaryAdvertisersThree.filter(function (n) { return !this.has(n) }, new Set(this.primaryAdvertisers))
    }
    // Competition Four
    if (type === 'competitionFour') {
      this.secondaryAdvertisersFour = new Array()
      let secondaryChannel_Four = this.publishersData_competitionFour.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersFour.push(i.company)
        });
      });
      this.secondaryAdvertisersFour = Array.from(new Set(this.secondaryAdvertisersFour.sort()));
      this.missingAdvertisers_ComFour = this.secondaryAdvertisersFour.filter(function (n) { return !this.has(n) }, new Set(this.primaryAdvertisers))
    }


  }

  topAdv_publishers(value, type) {


    if (type === 'competitionOne') {
      this.secondaryAdvertisersOne = new Array()
      let secondaryChannel_One = this.publishersData_competitionOne.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersOne.push(i)
        });
      });
      // Top Advertisers
      let TopAdvertisers_One = this.secondaryAdvertisersOne
        .map((i) => {
          let advertiser = i.company
          let net_spend = i.slot.reduce(function (a, b) { return a + b.net_spend }, 0)
          return { advertiser: advertiser, net_spend: net_spend }
        })

      // Filtering Top 20 Advertisers
      let Top20Advertisers_One = []

      TopAdvertisers_One.forEach(function (item) {
        var obj = Top20Advertisers_One.find(function (obj) { return obj.advertiser === item.advertiser })
        if (!obj) {
          let net_spend = TopAdvertisers_One
            .filter(i => i.advertiser === item.advertiser)
            .reduce(function (a, b) { return a + b.net_spend }, 0)

          Top20Advertisers_One.push({ 'advertiser': item.advertiser, 'net_spend': net_spend })
        }
      })

      Top20Advertisers_One.sort((a, b) => {
        let x = a.net_spend
        let y = b.net_spend
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
        .reverse()
        .splice(20)
      this.Top20Advertisers_One = Top20Advertisers_One;
    }

    // Competition Two
    if (type === 'competitionTwo') {
      this.secondaryAdvertisersTwo = new Array()
      let secondaryChannel_Two = this.publishersData_competitionTwo.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersTwo.push(i)
        });
      });
      // Top Advertisers
      let TopAdvertisers_Two = this.secondaryAdvertisersTwo
        .map((i) => {
          let advertiser = i.company
          let net_spend = i.slot.reduce(function (a, b) { return a + b.net_spend }, 0)
          return { advertiser: advertiser, net_spend: net_spend }
        })

      // Filtering Top 20 Advertisers
      let Top20Advertisers_Two = []

      TopAdvertisers_Two.forEach(function (item) {
        var obj = Top20Advertisers_Two.find(function (obj) { return obj.advertiser === item.advertiser })
        if (!obj) {
          let net_spend = TopAdvertisers_Two
            .filter(i => i.advertiser === item.advertiser)
            .reduce(function (a, b) { return a + b.net_spend }, 0)

          Top20Advertisers_Two.push({ 'advertiser': item.advertiser, 'net_spend': net_spend })
        }
      })

      Top20Advertisers_Two.sort((a, b) => {
        let x = a.net_spend
        let y = b.net_spend
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
        .reverse()
        .splice(20)

      this.Top20Advertisers_Two = Top20Advertisers_Two;
      // console.log(Top20Advertisers_Two)
    }

    // Competition Three
    if (type === 'competitionThree') {
      this.secondaryAdvertisersThree = new Array()
      let secondaryChannel_Three = this.publishersData_competitionThree.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersThree.push(i)
        });
      });
      // Top Advertisers
      let TopAdvertisers_Three = this.secondaryAdvertisersThree
        .map((i) => {
          let advertiser = i.company
          let net_spend = i.slot.reduce(function (a, b) { return a + b.net_spend }, 0)
          return { advertiser: advertiser, net_spend: net_spend }
        })

      // Filtering Top 20 Advertisers
      let Top20Advertisers_Three = []

      TopAdvertisers_Three.forEach(function (item) {
        var obj = Top20Advertisers_Three.find(function (obj) { return obj.advertiser === item.advertiser })
        if (!obj) {
          let net_spend = TopAdvertisers_Three
            .filter(i => i.advertiser === item.advertiser)
            .reduce(function (a, b) { return a + b.net_spend }, 0)

          Top20Advertisers_Three.push({ 'advertiser': item.advertiser, 'net_spend': net_spend })
        }
      })

      Top20Advertisers_Three.sort((a, b) => {
        let x = a.net_spend
        let y = b.net_spend
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
        .reverse()
        .splice(20)

      this.Top20Advertisers_Three = Top20Advertisers_Three;
      // console.log(Top20Advertisers_Three)

    }

    // Competition Four
    if (type === 'competitionFour') {
      this.secondaryAdvertisersFour = new Array()
      let secondaryChannel_Four = this.publishersData_competitionFour.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersFour.push(i)
        });
      });
      // Top Advertisers
      let TopAdvertisers_Four = this.secondaryAdvertisersFour
        .map((i) => {
          let advertiser = i.company
          let net_spend = i.slot.reduce(function (a, b) { return a + b.net_spend }, 0)
          return { advertiser: advertiser, net_spend: net_spend }
        })

      // Filtering Top 20 Advertisers
      let Top20Advertisers_Four = []

      TopAdvertisers_Four.forEach(function (item) {
        var obj = Top20Advertisers_Four.find(function (obj) { return obj.advertiser === item.advertiser })
        if (!obj) {
          let net_spend = TopAdvertisers_Four
            .filter(i => i.advertiser === item.advertiser)
            .reduce(function (a, b) { return a + b.net_spend }, 0)

          Top20Advertisers_Four.push({ 'advertiser': item.advertiser, 'net_spend': net_spend })
        }
      })

      Top20Advertisers_Four.sort((a, b) => {
        let x = a.net_spend
        let y = b.net_spend
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
        .reverse()
        .splice(20)

      this.Top20Advertisers_Four = Top20Advertisers_Four;
      // console.log(Top20Advertisers_Four)

    }


  }

  timeband_publishers(value, type) {


    if (type === 'competitionOne') {
      // Primary Channel
      this.secondaryAdvertisersOne = new Array()
      let secondaryChannel_One = this.publishersData_competitionOne.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersOne.push(i)
        });
      });
      // Top Advertisers
      let step1 = this.secondaryAdvertisersOne
        .map(i => {
          let advertiser = i.company
          let hourlySpend = i.slot.map(j => {
            // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)
            return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
          })

          return { advertiser: advertiser, hourlySpend }
        })


      // Step 2 = Array with Objects (Advertiser, Hour, Spend)
      let step2 = []
      step1.map(i => {
        let advertiser = i.advertiser
        i.hourlySpend.map(j => {
          step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
        })
      })
      // console.log(step2)
      // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)

      //Step 3 Map approach
      let advertisers = []
      step2.forEach(i => {
        if (!advertisers.includes(i.advertiser))
          advertisers.push(i.advertiser)
      })

      /*
          1. Loop over Advertisers Array
          2. Take 1 Advertiser at a time
          3. For loop 0 to 23 for 24 hours period
          4. Loop over Step2 Array
          5. If Advertiser==LoopValue and Hour==ForLoopValue
          6. Sum Net_Spend
          7. Push to Step3 Array as {Advertiser, Hour, Net_Spend}
      */

      // console.log(advertisers)
      let step3 = []
      advertisers.forEach(a => {
        let advertiser = a
        for (let h = 0; h < 24; h++) {
          let net_spend = 0
          step2.forEach(d => {
            if (d.advertiser === a && d.hour === h)
              net_spend += d.net_spend
          })
          if (net_spend !== 0) {
            step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
          }
          if (net_spend === 0) {
            step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
          }
        }
      })

      // console.log('step3')
      // console.log(step3)
      // let pepsi8pm =
      //   step3.filter(f => f.advertiser == 'UNILEVER PAKISTAN LTD' && f.hour === 22)

      // console.log(pepsi8pm)

      // Step 4
      /*
          1. Create a 24hour Loop
          2. Filter Step4 Array by Hour, then Sort(), then Reverse()
          3. Take the first value
       */

      let channeltimeband = new Array()
      for (var h = 0; h < 24; h++) {
        let TopAdvertiser = step3.filter(f => f.hour === h)

        TopAdvertiser.sort((a, b) => {
          let x = a.net_spend
          let y = b.net_spend
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }).reverse().splice(1)

        channeltimeband.push(TopAdvertiser[0])
        this.channelTimeband_One = channeltimeband;
        this.channelTimeband_One_ready = true;
      }
    }

    // Competition Two
    if (type === 'competitionTwo') {
      // Primary Channel
      this.secondaryAdvertisersTwo = new Array()
      let secondaryChannel_Two = this.publishersData_competitionTwo.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersTwo.push(i)
        });
      });
      // Top Advertisers
      let step1 = this.secondaryAdvertisersTwo
        .map(i => {
          let advertiserTwo = i.company
          let hourlySpend = i.slot.map(j => {
            // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)
            return { advertiserTwo: advertiserTwo, hour: j.hour, net_spend: j.net_spend }
          })

          return { advertiserTwo: advertiserTwo, hourlySpend }
        })

      // Step 2 = Array with Objects (AdvertiserTwo, Hour, Spend)
      let step2 = []
      step1.map(i => {
        let advertiserTwo = i.advertiserTwo
        i.hourlySpend.map(j => {
          step2.push({ advertiserTwo: advertiserTwo, hour: j.hour, net_spend: j.net_spend })
        })
      })
      // console.log(step2)
      // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)

      //Step 3 Map approach
      let advertiserTwos = []
      step2.forEach(i => {
        if (!advertiserTwos.includes(i.advertiserTwo))
          advertiserTwos.push(i.advertiserTwo)
      })

      /*
          1. Loop over AdvertiserTwos Array
          2. Take 1 AdvertiserTwo at a time
          3. For loop 0 to 23 for 24 hours period
          4. Loop over Step2 Array
          5. If AdvertiserTwo==LoopValue and Hour==ForLoopValue
          6. Sum Net_Spend
          7. Push to Step3 Array as {AdvertiserTwo, Hour, Net_Spend}
      */

      // console.log(advertiserTwos)
      let step3 = []
      advertiserTwos.forEach(a => {
        let advertiserTwo = a
        for (let h = 0; h < 24; h++) {
          let net_spend = 0
          step2.forEach(d => {
            if (d.advertiserTwo === a && d.hour === h)
              net_spend += d.net_spend
          })
          if (net_spend !== 0) {
            // console.log(advertiserTwo)
            // console.log('hour:', h, 'spend:', net_spend)
            step3.push({ 'advertiser': advertiserTwo, 'hour': h, 'net_spend': net_spend })
          }
          if (net_spend === 0) {
            step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
          }
        }
      })

      // console.log(step3)
      // let pepsi8pm =
      //   step3.filter(f => f.advertiserTwo == 'UNILEVER PAKISTAN LTD' && f.hour === 22)

      // console.log(pepsi8pm)

      // Step 4
      /*
          1. Create a 24hour Loop
          2. Filter Step4 Array by Hour, then Sort(), then Reverse()
          3. Take the first value
       */

      let channeltimeband = []
      for (var h = 0; h < 24; h++) {
        let TopAdvertiserTwo = step3.filter(f => f.hour === h)



        TopAdvertiserTwo.sort((a, b) => {
          let x = a.net_spend
          let y = b.net_spend
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }).reverse().splice(1)

        channeltimeband.push(TopAdvertiserTwo[0])
        this.channelTimeband_Two = channeltimeband;
        this.channelTimeband_Two_ready = true;
      }
    }

    // Competition Three
    if (type === 'competitionThree') {
      // Primary Channel
      this.secondaryAdvertisersThree = new Array()
      let secondaryChannel_Three = this.publishersData_competitionThree.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersThree.push(i)
        });
      });
      // Top Advertisers
      let step1 = this.secondaryAdvertisersThree
        .map(i => {
          let advertiserThree = i.company
          let hourlySpend = i.slot.map(j => {
            // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)
            return { advertiserThree: advertiserThree, hour: j.hour, net_spend: j.net_spend }
          })

          return { advertiserThree: advertiserThree, hourlySpend }
        })

      // Step 2 = Array with Objects (AdvertiserThree, Hour, Spend)
      let step2 = []
      step1.map(i => {
        let advertiserThree = i.advertiserThree
        i.hourlySpend.map(j => {
          step2.push({ advertiserThree: advertiserThree, hour: j.hour, net_spend: j.net_spend })
        })
      })
      // console.log(step2)
      // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)

      //Step 3 Map approach
      let advertiserThrees = []
      step2.forEach(i => {
        if (!advertiserThrees.includes(i.advertiserThree))
          advertiserThrees.push(i.advertiserThree)
      })

      /*
          1. Loop over AdvertiserThrees Array
          2. Take 1 AdvertiserThree at a time
          3. For loop 0 to 23 for 24 hours period
          4. Loop over Step2 Array
          5. If AdvertiserThree==LoopValue and Hour==ForLoopValue
          6. Sum Net_Spend
          7. Push to Step3 Array as {AdvertiserThree, Hour, Net_Spend}
      */

      // console.log(advertiserThrees)
      let step3 = []
      advertiserThrees.forEach(a => {
        let advertiserThree = a
        for (let h = 0; h < 24; h++) {
          let net_spend = 0
          step2.forEach(d => {
            if (d.advertiserThree === a && d.hour === h)
              net_spend += d.net_spend
          })
          if (net_spend !== 0) {
            // console.log(advertiserThree)
            // console.log('hour:', h, 'spend:', net_spend)
            step3.push({ 'advertiser': advertiserThree, 'hour': h, 'net_spend': net_spend })
          }
          if (net_spend === 0) {
            step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
          }
        }
      })

      // console.log(step3)
      // let pepsi8pm =
      //   step3.filter(f => f.advertiserThree == 'UNILEVER PAKISTAN LTD' && f.hour === 22)

      // console.log(pepsi8pm)

      // Step 4
      /*
          1. Create a 24hour Loop
          2. Filter Step4 Array by Hour, then Sort(), then Reverse()
          3. Take the first value
       */

      let channeltimeband = []
      for (var h = 0; h < 24; h++) {
        let TopAdvertiserThree = step3.filter(f => f.hour === h)



        TopAdvertiserThree.sort((a, b) => {
          let x = a.net_spend
          let y = b.net_spend
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }).reverse().splice(1)

        channeltimeband.push(TopAdvertiserThree[0])
        this.channelTimeband_Three = channeltimeband;
        this.channelTimeband_Three_ready = true;
      }
    }

    // Competition Four
    if (type === 'competitionFour') {
      // Primary Channel
      this.secondaryAdvertisersFour = new Array()
      let secondaryChannel_Four = this.publishersData_competitionFour.forEach(p => {
        p.tv.data.forEach(i => {
          this.secondaryAdvertisersFour.push(i)
        });
      });
      // Top Advertisers
      let step1 = this.secondaryAdvertisersFour
        .map(i => {
          let advertiserFour = i.company
          let hourlySpend = i.slot.map(j => {
            // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)
            return { advertiserFour: advertiserFour, hour: j.hour, net_spend: j.net_spend }
          })

          return { advertiserFour: advertiserFour, hourlySpend }
        })

      // Step 2 = Array with Objects (AdvertiserFour, Hour, Spend)
      let step2 = []
      step1.map(i => {
        let advertiserFour = i.advertiserFour
        i.hourlySpend.map(j => {
          step2.push({ advertiserFour: advertiserFour, hour: j.hour, net_spend: j.net_spend })
        })
      })
      // console.log(step2)
      // let net_spend = i.slot.reduce(function(a,b) { return a + b.net_spend }, 0)

      //Step 3 Map approach
      let advertiserFours = []
      step2.forEach(i => {
        if (!advertiserFours.includes(i.advertiserFour))
          advertiserFours.push(i.advertiserFour)
      })

      /*
          1. Loop over AdvertiserFours Array
          2. Take 1 AdvertiserFour at a time
          3. For loop 0 to 23 for 24 hours period
          4. Loop over Step2 Array
          5. If AdvertiserFour==LoopValue and Hour==ForLoopValue
          6. Sum Net_Spend
          7. Push to Step3 Array as {AdvertiserFour, Hour, Net_Spend}
      */

      // console.log(advertiserFours)
      let step3 = []
      advertiserFours.forEach(a => {
        let advertiserFour = a
        for (let h = 0; h < 24; h++) {
          let net_spend = 0
          step2.forEach(d => {
            if (d.advertiserFour === a && d.hour === h)
              net_spend += d.net_spend
          })
          if (net_spend !== 0) {
            // console.log(advertiserFour)
            // console.log('hour:', h, 'spend:', net_spend)
            step3.push({ 'advertiser': advertiserFour, 'hour': h, 'net_spend': net_spend })
          }
          if (net_spend === 0) {
            step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
          }
        }
      })

      // console.log(step3)
      // let pepsi8pm =
      //   step3.filter(f => f.advertiserFour == 'UNILEVER PAKISTAN LTD' && f.hour === 22)

      // console.log(pepsi8pm)

      // Step 4
      /*
          1. Create a 24hour Loop
          2. Filter Step4 Array by Hour, then Sort(), then Reverse()
          3. Take the first value
       */

      let channeltimeband = []
      for (var h = 0; h < 24; h++) {
        let TopAdvertiserFour = step3.filter(f => f.hour === h)

        TopAdvertiserFour.sort((a, b) => {
          let x = a.net_spend
          let y = b.net_spend
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }).reverse().splice(1)

        channeltimeband.push(TopAdvertiserFour[0])
        this.channelTimeband_Four = channeltimeband;
        this.channelTimeband_Four_ready = true;
      }
    }

  }

  weekly_chart(value, type) {

      // Primary Channel
      this.sortedByDay_Sun0 = new Array()
      this.sortedByDay_Mon1 = new Array()
      this.sortedByDay_Tue2 = new Array()
      this.sortedByDay_Wed3 = new Array()
      this.sortedByDay_Thu4 = new Array()
      this.sortedByDay_Fri5 = new Array()
      this.sortedByDay_Sat6 = new Array()
      let secondaryChannel_One = this.publishersData.forEach(p => {
        var d = new Date(p.date);
        var n = d.getDay();

        if (n === 0) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Sun0.push(i)
          });
          let step1 = this.sortedByDay_Sun0.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Sun0 = channeltimeband;
          }
        }

        if (n === 1) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Mon1.push(i)
          });
          let step1 = this.sortedByDay_Mon1.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Mon1 = channeltimeband;
          }
        }

        if (n === 2) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Tue2.push(i)
          });
          let step1 = this.sortedByDay_Tue2.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Tue2 = channeltimeband;
          }
        }

        if (n === 3) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Wed3.push(i)
          });
          let step1 = this.sortedByDay_Wed3.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Wed3 = channeltimeband;
          }
        }

        if (n === 4) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Thu4.push(i)
          });
          let step1 = this.sortedByDay_Thu4.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Thu4 = channeltimeband;
          }
        }

        if (n === 5) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Fri5.push(i)
          });
          let step1 = this.sortedByDay_Fri5.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Fri5 = channeltimeband;
          }
        }

        if (n === 6) {
          p.tv.data.forEach(i => {
            this.sortedByDay_Sat6.push(i)
          });
          let step1 = this.sortedByDay_Sat6.map(i => {
            let advertiser = i.company
            let hourlySpend = i.slot.map(j => {
              return { advertiser: advertiser, hour: j.hour, net_spend: j.net_spend }
            })
            return { advertiser: advertiser, hourlySpend }
          })
          // Step 2 = Array with Objects (Advertiser, Hour, Spend)
          let step2 = []
          step1.map(i => {
            let advertiser = i.advertiser
            i.hourlySpend.map(j => {
              step2.push({ advertiser: advertiser, hour: j.hour, net_spend: j.net_spend })
            })
          })
          //Step 3 Map approach
          let advertisers = []
          step2.forEach(i => {
            if (!advertisers.includes(i.advertiser))
              advertisers.push(i.advertiser)
          })
          
          let step3 = []
          advertisers.forEach(a => {
            let advertiser = a
            for (let h = 0; h < 24; h++) {
              let net_spend = 0
              step2.forEach(d => {
                if (d.advertiser === a && d.hour === h)
                  net_spend += d.net_spend
              })
              if (net_spend !== 0) {
                step3.push({ 'advertiser': advertiser, 'hour': h, 'net_spend': net_spend })
              }
              if (net_spend === 0) {
                step3.push({ 'advertiser': 'NO ACTIVITY', 'hour': h, 'net_spend': net_spend })
              }
            }
          })
    
          let channeltimeband = new Array()
          for (var h = 0; h < 24; h++) {
            let TopAdvertiser = step3.filter(f => f.hour === h)
    
            TopAdvertiser.sort((a, b) => {
              let x = a.net_spend
              let y = b.net_spend
              return ((x < y) ? -1 : ((x > y) ? 1 : 0))
            }).reverse().splice(1)
    
            channeltimeband.push(TopAdvertiser[0])
            this.dayArray_Sat6 = channeltimeband;
          }
        }
      });
      
  }


  getItems() {

    if (this.startDate) {
      this.sd = new Date(this.startDate);
      this.ed = new Date(this.endDate);
      this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));

    } else {
      this.sd = new Date('03-25-2018');
      this.ed = new Date('03-31-2018');
      this.days = Math.round(Math.abs((this.sd.getTime() - this.ed.getTime()) / (24 * 60 * 60 * 1000)));

    }

    const newSpotsData = new Array();

    if (this.authService.loggedInUserRole === 'Admin') {

      this.spotsCollection = this.afs.collection('dailySpots', ref => ref.orderBy('date', 'asc')
        .where('date', '>=', this.sd).where('date', '<=', this.ed));
      this.spots = this.spotsCollection.valueChanges().pipe(take(1));
      this.spots.subscribe(res => {
        res.forEach(p => {
          newSpotsData.push(p)
        })
        this.data = newSpotsData;
      })

    } else {

      this.userCategories.forEach(p => {
        this.spotsCollection = this.afs.collection('dailySpots', ref => ref.orderBy('date', 'asc')
          .where('date', '>=', this.sd).where('date', '<=', this.ed)
          .where('tv.industry', '==', p));
        this.spots = this.spotsCollection.valueChanges().pipe(take(1));
        this.spots.subscribe(res => {
          res.forEach(p => {
            newSpotsData.push(p)
          })
          this.data = newSpotsData;
        })
      });

    }

    // this.spots = this.spotsCollection.snapshotChanges().pipe(take(1)).map(changes => {
    //   return changes.map(a => {
    //     const data = a.payload.doc.data() as Spot;
    //     data.id = a.payload.doc.id;
    //     return data;
    //   });
    // }); 

    // this.spots = this.spotsCollection.valueChanges().pipe(take(1))

    return this.spots;
  }

  // On Calendar Change

  fetchData() {

    const Obs_data = new Array();
    this.showSpinner = true;
    // Functions go here

    if (this.url !== '/home') {
      this.getItems().subscribe((querySnapshot) => {
        // querySnapshot.forEach((doc) => {
        // });

        this.industryDocs = this.getIndustry();

        this.getIndustry().subscribe((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            Obs_data.push(doc);

          })
          this.industryCompareData = Obs_data;
          this.aggregation();

          if (this.url === '/' || this.url === '/advertisers') {
            this.advertisers();
          }

          if (this.url === '/advertisers/categories') {
            this.categories();
          }


          if (this.url === '/advertisers/brands' || this.url === '/advertisers/channels' || this.url === '/advertisers/slots' || this.url === '/advertisers/positions') {
            this.advertisers();

            // this.charts();

          }

          if (this.url === '/publishers/categories') {
            this.categories();
            this.charts_PubCategories();
            this.charts_PubChannelType();
          }

          // if (this.url === '/' || this.url === '/advertisers' || this.url === '/categories' || this.url === '/advertisers/slots') {
          //   this.charts();
          // }

          // this.charts();

          if (this.url === '/' || this.url === '/publishers/advertisers') {
            this.advertisers();
          }

          this.showSpinner = false;


        })

        // this.data = Obs_data;
        // console.log('data');
        // console.log(this.data);
      });
    }

    if (this.url === '/home') {
      this.industryDocs = this.getIndustry();

      this.getIndustry().subscribe((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          Obs_data.push(doc);
        })
        this.industryCompareData = Obs_data;
        this.industry_aggregation();
        this.advertisers();

        this.dataAvailable = false;
        this.showSpinner = false;
      })
    }




  }

  // itererateRecords() {
  //   let myData = [15253447072090,15253447072091,15253447072092,15253447072093,15253447072094,15253447072095,15253447072096,15253447072097,15253447072098,15253447072099,152534470720910,152534470720911,152534470720912,152534470720913,152534470720914,152534470720915,152534470720916,152534470720917,152534470720918,152534470720919,152534470720920,152534470720921,152534470720922,152534470720923,152534470720924,152534470720925,152534470720926,152534470720927,152534470720928,152534470720929,152534470720930,152534470720931,152534470720932,152534470720933,152534470720934,152534470720935,152534470720936,152534470720937,152534470720938,152534470720939,152534470720940,152534470720941,152534470720942,152534470720943,152534470720944,152534470720945,152534470720946,152534470720947,152534470720948,152534470720949,152534470720950,152534470720951,152534470720952,152534470720953,152534470720954,152534470720955,152534470720956,152534470720957,152534470720958,152534470720959,152534470720960,152534470720961,152534470720962,152534470720963,152534470720964,152534470720965,152534470720966,152534470720967,152534470720968,152534470720969,152534470720970,152534470720971,152534470720972,152534470720973,152534470720974,152534470720975,152534470720976,152534470720977,152534470720978,152534470720979,152534470720980,152534470720981,152534470720982,152534470720983,152534470720984,152534470720985,152534470720986,152534470720987,152534470720988,152534470720989,152534470720990,152534470720991,152534470720992,152534470720993,152534470720994,152534470720995,152534470720996,152534470720997,152534470720998,152534470720999,1525344707209100,1525344707209101,1525344707209102,1525344707209103,1525344707209104,1525344707209105,1525344707209106,1525344707209107,1525344707209108,1525344707209109,1525344707209110,1525344707209111,1525344707209112,1525344707209113,1525344707209114,1525344707209115,1525344707209116,1525344707209117,1525344707209118,1525344707209119,1525344707209120,1525344707209121,1525344707209122,1525344707209123,1525344707209124,1525344707209125,1525344707209126,1525344707209127,1525344707209128,1525344707209129,1525344707209130,1525344707209131,1525344707209132,1525344707209133,1525344707209134,1525344707209135,1525344707209136,1525344707209137,1525344707209138,1525344707209139,1525344707209140,1525344707209141,1525344707209142,1525344707209143,1525344707209144,1525344707209145,1525344707209146,1525344707209147,1525344707209148,1525344707209149,1525344707209150,1525344707209151,1525344707209152,1525344707209153,1525344707209154,1525344707209155,1525344707209156,1525344707209157,1525344707209158,1525344707209159,1525344707209160,1525344707209161,1525344707209162,1525344707209163,1525344707209164,1525344707209165,1525344707209166,1525344707209167,1525344707209168,1525344707209169,1525344707209170,1525344707209171,1525344707209172,1525344707209173,1525344707209174,1525344707209175,1525344707209176,1525344707209177,1525344707209178,1525344707209179,1525344707209180,1525344707209181,1525344707209182,1525344707209183,1525344707209184,1525344707209185,1525344707209186,1525344707209187,1525344707209188,1525344707209189,1525344707209190,1525344707209191,1525344707209192,1525344707209193,1525344707209194,1525344707209195,1525344707209196,1525344707209197,1525344707209198,1525344707209199,1525344707209200,1525344707209201,1525344707209202,1525344707209203,1525344707209204,1525344707209205,1525344707209206,1525344707209207,1525344707209208,1525344707209209,1525344707209210,1525344707209211,1525344707209212,1525344707209213,1525344707209214,1525344707209215,1525344707209216,1525344707209217,1525344707209218,1525344707209219,1525344707209220,1525344707209221,1525344707209222,1525344707209223,1525344707209224,1525344707209225,1525344707209226,1525344707209227,1525344707209228,1525344707209229,1525344707209230,1525344707209231,1525344707209232,1525344707209233,1525344707209234,1525344707209235,1525344707209236,1525344707209237,1525344707209238,1525344707209239,1525344707209240,1525344707209241,1525344707209242,1525344707209243,1525344707209244,1525344707209245,1525344707209246,1525344707209247,1525344707209248,1525344707209249,1525344707209250,1525344707209251,1525344707209252,1525344707209253,1525344707209254,1525344707209255,1525344707209256,1525344707209257,1525344707209258,1525344707209259,1525344707209260,1525344707209261,1525344707209262,1525344707209263,1525344707209264,1525344707209265,1525344707209266,1525344707209267,1525344707209268,1525344707209269,1525344707209270,1525344707209271,1525344707209272,1525344707209273,1525344707209274,1525344707209275,1525344707209276,1525344707209277,1525344707209278,1525344707209279,1525344707209280,1525344707209281,1525344707209282,1525344707209283,1525344707209284,1525344707209285,1525344707209286,1525344707209287,1525344707209288,1525344707209289,1525344707209290,1525344707209291,1525344707209292,1525344707209293,1525344707209294,1525344707209295,1525344707209296,1525344707209297,1525344707209298,1525344707209299,1525344707209300,1525344707209301,1525344707209302,1525344707209303,1525344707209304,1525344707209305,1525344707209306,1525344707209307,1525344707209308,1525344707209309,1525344707209310,1525344707209311,1525344707209312,1525344707209313,1525344707209314,1525344707209315,1525344707209316,1525344707209317,1525344707209318,1525344707209319,1525344707209320,1525344707209321,1525344707209322,1525344707209323,1525344707209324,1525344707209325,1525344707209326,1525344707209327,1525344707209328,1525344707209329,1525344707209330,1525344707209331,1525344707209332,1525344707209333,1525344707209334,1525344707209335,1525344707209336,1525344707209337,1525344707209338,1525344707209339,1525344707209340,1525344707209341,1525344707209342,1525344707209343,1525344707209344,1525344707209345,1525344707209346,1525344707209347,1525344707209348,1525344707209349,1525344707209350,1525344707209351,1525344707209352,1525344707209353,1525344707209354,1525344707209355,1525344707209356,1525344707209357,1525344707209358,1525344707209359,1525344707209360,1525344707209361,1525344707209362,1525344707209363,1525344707209364,1525344707209365,1525344707209366,1525344707209367,1525344707209368,1525344707209369,1525344707209370,1525344707209371,1525344707209372,1525344707209373,1525344707209374,1525344707209375,1525344707209376,1525344707209377,1525344707209378,1525344707209379,1525344707209380,1525344707209381,1525344707209382,1525344707209383,1525344707209384,1525344707209385,1525344707209386,1525344707209387,1525344707209388,1525344707209389,1525344707209390,1525344707209391,1525344707209392,1525344707209393,1525344707209394,1525344707209395,1525344707209396,1525344707209397,1525344707209398,1525344707209399,1525344707209400,1525344707209401,1525344707209402,1525344707209403,1525344707209404,1525344707209405,1525344707209406,1525344707209407,1525344707209408,1525344707209409,1525344707209410,1525344707209411,1525344707209412,1525344707209413,1525344707209414,1525344707209415,1525344707209416,1525344707209417,1525344707209418,1525344707209419,1525344707209420,1525344707209421,1525344707209422,1525344707209423,1525344707209424,1525344707209425,1525344707209426,1525344707209427,1525344707209428,1525344707209429,1525344707209430,1525344707209431,1525344707209432,1525344707209433,1525344707209434,1525344707209435,1525344707209436,1525344707209437,1525344707209438,1525344707209439,1525344707209440,1525344707209441,1525344707209442,1525344707209443,1525344707209444,1525344707209445,1525344707209446,1525344707209447,1525344707209448,1525344707209449,1525344707209450,1525344707209451,1525344707209452,1525344707209453,1525344707209454,1525344707209455,1525344707209456,1525344707209457,1525344707209458,1525344707209459,1525344707209460,1525344707209461,1525344707209462,1525344707209463,1525344707209464,1525344707209465,1525344707209466,1525344707209467,1525344707209468,1525344707209469,1525344707209470,1525344707209471,1525344707209472,1525344707209473,1525344707209474,1525344707209475,1525344707209476,1525344707209477,1525344707209478,1525344707209479,1525344707209480,1525344707209481,1525344707209482,1525344707209483,1525344707209484,1525344707209485,1525344707209486,1525344707209487,1525344707209488,1525344707209489,1525344707209490,1525344707209491,1525344707209492,1525344707209493,1525344707209494,1525344707209495,1525344707209496,1525344707209497,1525344707209498,1525344707209499,1525344707209500,1525344707209501,1525344707209502,1525344707209503,1525344707209504,1525344707209505,1525344707209506,1525344707209507,1525344707209508,1525344707209509,1525344707209510,1525344707209511,1525344707209512,1525344707209513,1525344707209514,1525344707209515,1525344707209516,1525344707209517,1525344707209518,1525344707209519,1525344707209520,1525344707209521,1525344707209522,1525344707209523,1525344707209524,1525344707209525,1525344707209526,1525344707209527,1525344707209528,1525344707209529,1525344707209530,1525344707209531,1525344707209532,1525344707209533,1525344707209534,1525344707209535,1525344707209536,1525344707209537,1525344707209538,1525344707209539,1525344707209540,1525344707209541,1525344707209542,1525344707209543,1525344707209544,1525344707209545,1525344707209546,1525344707209547,1525344707209548,1525344707209549,1525344707209550,1525344707209551,1525344707209552,1525344707209553,1525344707209554,1525344707209555,1525344707209556,1525344707209557,1525344707209558,1525344707209559,1525344707209560,1525344707209561,1525344707209562,1525344707209563,1525344707209564,1525344707209565,1525344707209566,1525344707209567,1525344707209568,1525344707209569,1525344707209570,1525344707209571,1525344707209572,1525344707209573,1525344707209574,1525344707209575,1525344707209576,1525344707209577,1525344707209578,1525344707209579,1525344707209580,1525344707209581,1525344707209582,1525344707209583,1525344707209584,1525344707209585,1525344707209586,1525344707209587,1525344707209588,1525344707209589,1525344707209590,1525344707209591,1525344707209592,1525344707209593,1525344707209594,1525344707209595,1525344707209596,1525344707209597,1525344707209598,1525344707209599,1525344707209600,1525344707209601,1525344707209602,1525344707209603,1525344707209604,1525344707209605,1525344707209606,1525344707209607,1525344707209608,1525344707209609,1525344707209610,1525344707209611,1525344707209612,1525344707209613,1525344707209614,1525344707209615,1525344707209616,1525344707209617,1525344707209618,1525344707209619,1525344707209620,1525344707209621,1525344707209622,1525344707209623,1525344707209624,1525344707209625,1525344707209626,1525344707209627,1525344707209628,1525344707209629,1525344707209630,1525344707209631,1525344707209632,1525344707209633,1525344707209634,1525344707209635,1525344707209636,1525344707209637,1525344707209638,1525344707209639,1525344707209640,1525344707209641,1525344707209642,1525344707209643,1525344707209644,1525344707209645,1525344707209646,1525344707209647,1525344707209648,1525344707209649,1525344707209650,1525344707209651,1525344707209652,1525344707209653,1525344707209654,1525344707209655,1525344707209656,1525344707209657,1525344707209658,1525344707209659,1525344707209660,1525344707209661,1525344707209662,1525344707209663,1525344707209664,1525344707209665,1525344707209666,1525344707209667,1525344707209668,1525344707209669,1525344707209670,1525344707209671,1525344707209672,1525344707209673,1525344707209674,1525344707209675,1525344707209676,1525344707209677,1525344707209678,1525344707209679,1525344707209680,1525344707209681,1525344707209682,1525344707209683,1525344707209684,1525344707209685,1525344707209686,1525344707209687,1525344707209688,1525344707209689,1525344707209690,1525344707209691,1525344707209692,1525344707209693,1525344707209694,1525344707209695,1525344707209696,1525344707209697,1525344707209698,1525344707209699,1525344707209700,1525344707209701,1525344707209702,1525344707209703,1525344707209704,1525344707209705,1525344707209706,1525344707209707,1525344707209708,1525344707209709,1525344707209710,1525344707209711,1525344707209712,1525344707209713,1525344707209714,1525344707209715,1525344707209716,1525344707209717,1525344707209718,1525344707209719,1525344707209720,1525344707209721,1525344707209722,1525344707209723,1525344707209724,1525344707209725,1525344707209726,1525344707209727,1525344707209728,1525344707209729,1525344707209730,1525344707209731,1525344707209732,1525344707209733,1525344707209734,1525344707209735,1525344707209736,1525344707209737,1525344707209738,1525344707209739,1525344707209740,1525344707209741,1525344707209742,1525344707209743,1525344707209744,1525344707209745,1525344707209746,1525344707209747,1525344707209748,1525344707209749,1525344707209750,1525344707209751,1525344707209752,1525344707209753,1525344707209754,1525344707209755,1525344707209756,1525344707209757,1525344707209758,1525344707209759,1525344707209760,1525344707209761,1525344707209762,1525344707209763,1525344707209764,1525344707209765,1525344707209766,1525344707209767,1525344707209768,1525344707209769,1525344707209770,1525344707209771,1525344707209772,1525344707209773,1525344707209774,1525344707209775,1525344707209776,1525344707209777,1525344707209778,1525344707209779,1525344707209780,1525344707209781,1525344707209782,1525344707209783,1525344707209784,1525344707209785,1525344707209786,1525344707209787,1525344707209788,1525344707209789,1525344707209790,1525344707209791,1525344707209792,1525344707209793,1525344707209794,1525344707209795,1525344707209796,1525344707209797,1525344707209798,1525344707209799,1525344707209800,1525344707209801,1525344707209802,1525344707209803,1525344707209804,1525344707209805,1525344707209806,1525344707209807,1525344707209808,1525344707209809,1525344707209810,1525344707209811,1525344707209812,1525344707209813,1525344707209814,1525344707209815,1525344707209816,1525344707209817,1525344707209818,1525344707209819,1525344707209820,1525344707209821,1525344707209822,1525344707209823,1525344707209824,1525344707209825,1525344707209826,1525344707209827,1525344707209828,1525344707209829,1525344707209830,1525344707209831,1525344707209832,1525344707209833,1525344707209834,1525344707209835,1525344707209836,1525344707209837,1525344707209838,1525344707209839,1525344707209840,1525344707209841,1525344707209842,1525344707209843,1525344707209844,1525344707209845,1525344707209846,1525344707209847,1525344707209848,1525344707209849,1525344707209850,1525344707209851,1525344707209852,1525344707209853,1525344707209854,1525344707209855,1525344707209856,1525344707209857,1525344707209858,1525344707209859,1525344707209860,1525344707209861,1525344707209862,1525344707209863,1525344707209864,1525344707209865,1525344707209866,1525344707209867,1525344707209868,1525344707209869,1525344707209870,1525344707209871,1525344707209872,1525344707209873,1525344707209874,1525344707209875,1525344707209876,1525344707209877,1525344707209878,1525344707209879,1525344707209880,1525344707209881,1525344707209882,1525344707209883,1525344707209884,1525344707209885,1525344707209886,1525344707209887,1525344707209888,1525344707209889,1525344707209890,1525344707209891,1525344707209892,1525344707209893,1525344707209894,1525344707209895,1525344707209896,1525344707209897,1525344707209898,1525344707209899,1525344707209900,1525344707209901,1525344707209902,1525344707209903,1525344707209904,1525344707209905,1525344707209906,1525344707209907,1525344707209908,1525344707209909,1525344707209910,1525344707209911,1525344707209912,1525344707209913,1525344707209914,1525344707209915,1525344707209916,1525344707209917,1525344707209918,1525344707209919,1525344707209920,1525344707209921,1525344707209922,1525344707209923];

  //   this.dailySpotsCollection = this.afs.collection('dailySpots');

  //   myData.forEach( p => {
  //    this.dailySpotsCollection.doc("" + p).delete().then(function() {
  //       console.log("Document successfully deleted!");
  //   }).catch(function(error) {
  //       console.error("Error removing document: ", error);
  //   });

  //   })

  // }

  industry_aggregation() {

    // console.log('Industry Aggregation')
    const brands = new Array();
    const channels = new Array();
    const categories = new Array();
    const slots = new Array();
    const positions = new Array();

    this.industryCompareData.forEach(p => {
      // console.log(p)
      p.industry.channels.forEach(d => {
        d.day = p.day;
        channels.push(d)
      });

      p.industry.slots.forEach(s => {
        slots.push(s)
      });

      p.industry.brands.forEach(b => {
        brands.push(b)
      });

      p.industry.categories.forEach(i => {
        i.category = i.industry
        categories.push(i)
      });


    });

    this.aggregated_dataByBrands_Complete = brands;
    this.aggregated_dataByChannels_Complete = channels;
    this.aggregated_dataBySlots_Complete = slots;
    this.aggregated_dataByPositions_Complete = positions;

    this.aggregated_dataByBrands = this.aggregated_dataByBrands_Complete;
    this.aggregated_dataByChannels = this.aggregated_dataByChannels_Complete;
    this.aggregated_dataBySlots = this.aggregated_dataBySlots_Complete;
    this.aggregated_dataByPositions = this.aggregated_dataByPositions_Complete;



    // this.industryCompareData.forEach(p => {
    //   console.log('p');
    //   console.log(p);
    // });



    this.aggregated_days = this.groupBy(this.industryCompareData, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_daysIndustry = this.groupBy(this.industryCompareData, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brands = this.groupBy(brands, 'brand', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categories = this.groupBy(categories, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_channels = this.groupBy(channels, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_slots = this.groupBy(slots, 'slot', 'net_spend', 'total_minutes', 'count');
    this.aggregated_positions = this.groupBy(positions, 'position', 'net_spend', 'total_minutes', 'count');

    this.aggregated_positions.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.top_companies = this.groupBy(channels, 'company', 'net_spend', 'total_minutes', 'count');
    this.top_companies.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_channels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_brands.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.top_categories = this.aggregated_categories;
    this.top_channels = this.aggregated_channels;



    const seasonality_spend = new Array();
    const seasonality_minutes = new Array();
    const seasonality_count = new Array();
    const seasonality_days = new Array();

    let newSumCount;
    let newSumMinutes;
    let newSumSpend;
    let newSumofArray;
    newSumofArray = 0;
    newSumSpend = 0;
    newSumMinutes = 0;
    newSumCount = 0;


    this.aggregated_daysIndustry.forEach(p => {
      // console.log(p)
      newSumSpend += p.net_spend;
      seasonality_spend.push(p.net_spend);
      newSumMinutes += p.total_minutes;
      seasonality_minutes.push(p.total_minutes);
      newSumCount += p.count;
      seasonality_count.push(p.count);
      seasonality_days.push(p.day);
    });
    this.industry_total_spend = newSumSpend;
    this.industry_total_minutes = newSumMinutes;
    this.industry_total_count = newSumCount;
    this.industry_seasonality_spend = seasonality_spend;
    this.industry_seasonality_minutes = seasonality_minutes;
    this.industry_seasonality_count = seasonality_count;
    this.industry_seasonality_days = seasonality_days;

  }

  aggregation() {

    const brands = new Array();
    const channels = new Array();
    const slots = new Array();
    const positions = new Array();


    this.data.forEach(p => {
      // For Brands, Channels & Slots

      p.tv.brands.forEach(d => {
        d.category = d.industry;
        d.sub_category = d.product;
        delete d.industry;
        delete d.product;
        d.channels.forEach(c => {
          if (!c.genre) {
            if (c.channel === 'AXN') {
              c.genre = 'MOVIES'
            }
            if (c.channel === 'ZAIQA ENT') {
              c.genre = 'ENTERTAINMENT'
            }
          }
          if (c.channel === 'PTV' || c.channel === 'PTV SPORTS' || c.channel === 'ATV') {
            c.channel_type = 'TERRESTRIAL'
          } else {
            c.channel_type = 'SATELLITE'
          }
          c.brand = d.brand;
          c.company = d.company;
          c.sub_category = d.sub_category;
          c.category = d.category;
          c.day = p.day;
          channels.push(c);
        });

        // For Slots

        d.slots.forEach(s => {
          s.brand = d.brand;
          s.company = d.company;
          s.sub_category = d.sub_category;
          s.category = d.category;
          s.day = p.day;
          slots.push(s);
        });

        // For Positions

        d.positions.forEach(po => {
          po.brand = d.brand;
          po.company = d.company;
          po.sub_category = d.sub_category;
          po.category = d.category;
          po.day = p.day;
          positions.push(po);

        });

      });
    });




    this.aggregated_dataByBrands_Complete = channels;
    this.aggregated_dataByChannels_Complete = channels;
    this.aggregated_dataBySlots_Complete = slots;
    this.aggregated_dataByPositions_Complete = positions;

    this.aggregated_dataByBrands = this.aggregated_dataByBrands_Complete;
    this.aggregated_dataByChannels = this.aggregated_dataByChannels_Complete;
    this.aggregated_dataBySlots = this.aggregated_dataBySlots_Complete;
    this.aggregated_dataByPositions = this.aggregated_dataByPositions_Complete;





    // this.industryCompareData.forEach(p => {
    //   console.log('p');
    //   console.log(p);
    // });


    this.aggregated_days = this.groupBy(channels, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_daysIndustry = this.groupBy(this.industryCompareData, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brands = this.groupBy(channels, 'brand', 'net_spend', 'total_minutes', 'count');

    this.aggregated_categories = this.groupBy(channels, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_channels = this.groupBy(channels, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_slots = this.groupBy(slots, 'slot', 'net_spend', 'total_minutes', 'count');
    this.aggregated_positions = this.groupBy(positions, 'position', 'net_spend', 'total_minutes', 'count');

    this.aggregated_positions.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.top_companies = this.groupBy(channels, 'company', 'net_spend', 'total_minutes', 'count');
    this.top_companies.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_channels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_brands.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.top_categories = this.aggregated_categories;


    const seasonality_spend = new Array();
    const seasonality_minutes = new Array();
    const seasonality_count = new Array();
    const seasonality_days = new Array();

    let newSumCount;
    let newSumMinutes;
    let newSumSpend;
    let newSumofArray;
    newSumofArray = 0;
    newSumSpend = 0;
    newSumMinutes = 0;
    newSumCount = 0;


    this.aggregated_daysIndustry.forEach(p => {
      newSumSpend += p.net_spend;
      seasonality_spend.push(p.net_spend);
      newSumMinutes += p.total_minutes;
      seasonality_minutes.push(p.total_minutes);
      newSumCount += p.count;
      seasonality_count.push(p.count);
      seasonality_days.push(p.day);
    });
    this.industry_total_spend = newSumSpend;
    this.industry_total_minutes = newSumMinutes;
    this.industry_total_count = newSumCount;
    this.industry_seasonality_spend = seasonality_spend;
    this.industry_seasonality_minutes = seasonality_minutes;
    this.industry_seasonality_count = seasonality_count;
    this.industry_seasonality_days = seasonality_days;



  }


  compareAdvertisers() {

    if (this.seasonality_trend_chart) {
      this.seasonality_trend_chart.destroy();
      this.total_spend_chart.destroy();
      this.total_minutes_chart.destroy();
      this.total_count_chart.destroy();
      this.top_slots_chart.destroy();

      // if (this.slots_ByBrandchart) {
      //  console.log('ON PAGE')
      //   this.top_slots_chart.destroy();
      //   this.slots_ByBrandchart.destroy();
      //   this.slots_ByCategoryChart.destroy();
      //   this.slots_ByCompanyChart.destroy();
      // }

      if (this.positions_ByBrandchart) {
        this.positions_ByBrandchart.destroy();
        this.positions_ByCompanyChart.destroy();
        this.positions_RegularVsPremium.destroy();
        this.positions_ByCategoryChart.destroy();
      }



    }


    // console.log('Compare Function')
    const secondary_selected_advData = new Array();
    const secondary_selected_advDataByChannels = new Array();
    const secondary_selected_advDataBySlots = new Array();
    const secondary_selected_adv_sos = new Array();
    const secondary_selected_adv_som = new Array();
    const secondary_selected_adv_sof = new Array();
    const secondary_selected_adv_brandNames = new Array();
    const secondary_list_bran_adv = new Array();
    const secondary_list_channelby_adv = new Array();
    const secondary_list_slots_adv = new Array();
    const secondary_list_positions_adv = new Array();
    const secondary_selected_advDataByPositions = new Array();

    const secondary_genreWiseData = new Array();

    const secondary_seasonality_spend = new Array();
    const secondary_seasonality_minutes = new Array();
    const secondary_seasonality_count = new Array();
    const secondary_seasonality_days = new Array();
    const secondary_seasonality_avgSpend = new Array();

    let sumCount;
    let sumMinutes;
    let sumSpend;
    let sumofArray;
    sumofArray = 0;
    sumCount = 0;
    sumMinutes = 0;
    sumSpend = 0;



    if (this.url === '/advertisers/slots') {
      this.aggregated_dataBySlots.forEach(p => {
        if (this.secondary_selected_adv) {
          if (this.secondary_selected_adv && p.company === this.secondary_selected_adv) {
            secondary_list_slots_adv.push(p);
            if (this.selected_adv_slot) {
              if (p.slot === this.selected_adv_slot) {
                secondary_selected_advDataBySlots.push(p);
                secondary_selected_advData.push(p);
              }
            } else {
              secondary_selected_advDataBySlots.push(p);
              secondary_selected_advData.push(p);
            }
          }
        } else {
          secondary_selected_advDataBySlots.push(p);
          secondary_selected_advData.push(p);
        }
      });
    } else {
      if (this.url === '/advertisers/positions') {
        this.aggregated_dataByPositions.forEach(p => {
          if (this.secondary_selected_adv) {
            if (this.secondary_selected_adv && p.company === this.secondary_selected_adv) {
              secondary_list_positions_adv.push(p);

              if (this.secondary_selected_adv_position) {
                if (p.position === this.secondary_selected_adv_position) {
                  secondary_selected_advDataByPositions.push(p);
                  secondary_selected_advData.push(p);
                }
              } else {
                secondary_selected_advDataByPositions.push(p);
                secondary_selected_advData.push(p);
              }
            }
          }
          else {
            secondary_selected_advDataByPositions.push(p);
            secondary_selected_advData.push(p);
          }
        });
      } else {

        this.aggregated_dataByBrands.forEach(p => {
          if (this.secondary_selected_adv) {
            // if (this.selected_adv && p.company === this.selected_adv) {
            if (p.company === this.secondary_selected_adv) {
              secondary_list_bran_adv.push(p);
              secondary_list_channelby_adv.push(p);

              if (this.secondary_selected_adv_brand || this.secondary_selected_adv_channel) {
                if (p.brand === this.secondary_selected_adv_brand || p.channel === this.secondary_selected_adv_channel) {
                  secondary_selected_advData.push(p);
                  secondary_selected_advDataByChannels.push(p);
                }
              } else {
                secondary_selected_advData.push(p);
                secondary_selected_advDataByChannels.push(p);
              }
            }
          }
          else {
            secondary_selected_advData.push(p);
            secondary_selected_advDataByChannels.push(p);
          }
        });

        this.aggregated_dataBySlots.forEach(p => {
          if (this.secondary_selected_adv) {
            if (this.secondary_selected_adv && p.company === this.secondary_selected_adv) {


              if (this.secondary_selected_adv_brand) {
                if (p.brand === this.secondary_selected_adv_brand) {
                  secondary_selected_advDataBySlots.push(p);
                }
              } else {
                secondary_selected_advDataBySlots.push(p);
              }
            }
          }
          else {
            secondary_selected_advDataBySlots.push(p);
          }
        });

      }
    }






    this.secondary_list_slots_adv = this.groupBy(secondary_list_slots_adv, 'slot', 'net_spend', 'total_minutes', 'count');
    this.secondary_list_positions_adv = this.groupBy(secondary_list_positions_adv, 'position', 'net_spend', 'total_minutes', 'count');

    this.secondary_list_positions_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_days = this.groupBy(secondary_selected_advData, 'day', 'net_spend', 'total_minutes', 'count');
    this.secondary_aggregated_brands = this.groupBy(secondary_selected_advData, 'brand', 'net_spend', 'total_minutes', 'count');
    this.secondary_aggregated_categories = this.groupBy(secondary_selected_advData, 'category', 'net_spend', 'total_minutes', 'count');
    this.secondary_aggregated_channels = this.groupBy(secondary_selected_advDataByChannels, 'channel', 'net_spend', 'total_minutes', 'count');
    this.secondary_aggregated_slots = this.groupBy(secondary_selected_advDataBySlots, 'slot', 'net_spend', 'total_minutes', 'count');
    this.secondary_list_brandby_adv = this.groupBy(secondary_list_bran_adv, 'brand', 'net_spend', 'total_minutes', 'count');
    this.secondary_list_channelby_adv = this.groupBy(secondary_list_channelby_adv, 'channel', 'net_spend', 'total_minutes', 'count');
    this.secondary_aggregated_positions = this.groupBy(secondary_selected_advDataByPositions, 'position', 'net_spend', 'total_minutes', 'count');

    var secondary_counts = secondary_selected_advData.reduce((p, c) => {
      var name = c.brand;
      if (!p.hasOwnProperty(name)) {
        p[name] = 0;
      }
      p[name]++;
      return p;
    }, {});

    var secondary_countsExtended = Object.keys(secondary_counts).map(k => {
      return { name: k, count: secondary_counts[k] };
    });

    this.secondary_countsExtended = secondary_countsExtended;

    this.secondary_aggregated_brands.forEach(p => {
      this.secondary_countsExtended.forEach(c => {
        if (p.brand == c.name) {
          p.activeDays_count = c.count;

        }
      });
    });

    this.secondary_list_channelby_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.secondary_list_brandby_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_positions.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.secondary_aggregated_brands.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.secondary_aggregated_channels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_slots.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    this.secondary_aggregated_days.forEach(p => {
      sumSpend += p.net_spend;
      secondary_seasonality_spend.push(p.net_spend);
      sumMinutes += p.total_minutes;
      secondary_seasonality_minutes.push(p.total_minutes);
      sumCount += p.count;
      secondary_seasonality_count.push(p.count);
      secondary_seasonality_days.push(p.day);
    });
    this.secondary_total_spend = sumSpend;
    this.secondary_total_minutes = sumMinutes;
    this.secondary_total_count = sumCount;
    this.secondary_seasonality_spend = secondary_seasonality_spend;
    this.secondary_seasonality_minutes = secondary_seasonality_minutes;
    this.secondary_seasonality_count = secondary_seasonality_count;
    this.secondary_seasonality_days = secondary_seasonality_days;

    this.secondary_list_brandby_adv = this.secondary_list_brandby_adv;

    for (let i = 0; i < this.secondary_seasonality_spend.length; i++) {
      sumofArray += this.secondary_seasonality_spend[i];
    }

    this.secondary_averageSpendPerDay = sumofArray / this.secondary_seasonality_spend.length;

    for (let i = 0; i < this.secondary_seasonality_days.length; i++) {
      secondary_seasonality_avgSpend.push(this.secondary_averageSpendPerDay);
    }
    this.secondary_seasonality_avgSpend = secondary_seasonality_avgSpend;

    const arrMax = arr => Math.max(...arr);
    const arrMin = arr => Math.min(...arr);
    this.secondary_maxSpend_value = arrMax(this.secondary_seasonality_spend);
    this.secondary_minSpend_value = arrMin(this.secondary_seasonality_spend);

    const arrMax_index = this.secondary_seasonality_spend.indexOf(this.secondary_maxSpend_value);
    this.secondary_maxSpend_day = this.secondary_seasonality_days[arrMax_index];

    const arrMin_index = this.secondary_seasonality_spend.indexOf(this.secondary_minSpend_value);
    this.secondary_minSpend_day = this.secondary_seasonality_days[arrMin_index];

    const secondary_slots_name = new Array();
    const secondary_slots_value = new Array();
    const secondary_slots_sos = new Array();

    if (this.secondary_slots_name) {
      delete this.secondary_slots_name;
      delete this.secondary_slots_value;
    }


    this.secondary_aggregated_slots.forEach(p => {
      secondary_slots_name.push(p.slot);
      secondary_slots_value.push(p.net_spend);
      secondary_slots_sos.push(this.numberRound(p.net_spend / this.secondary_total_spend * 100, 2))

    });

    this.secondary_slots_name = secondary_slots_name;
    this.secondary_slots_value = secondary_slots_value;
    this.secondary_slots_sos = secondary_slots_sos;




    this.secondary_topBrand_Single = this.secondary_aggregated_brands[0];
    let sumForBrandAvg;
    sumForBrandAvg = 0;
    this.secondary_aggregated_brands.forEach(p => {
      sumForBrandAvg += p.net_spend;

    });

    this.secondary_averageSpendByBrands = sumForBrandAvg / this.secondary_aggregated_brands.length;

    this.secondary_lastBrand_Single = this.secondary_aggregated_brands.slice(-1)[0];


    if (this.secondary_total_spend == 0) {
      this.secondary_topBrandSOS = 0;
      this.secondary_lastBrandSOS = 0;
      this.alertMessage = this.secondary_selected_adv + ' is not active during the selected period.';


    } else {
      this.secondary_topBrandSOS = this.secondary_topBrand_Single.net_spend / this.secondary_total_spend * 100;
      this.secondary_lastBrandSOS = this.secondary_lastBrand_Single.net_spend / this.secondary_total_spend * 100;
      this.alertMessage = '';
    }

    this.secondary_aggregated_brands.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.secondary_total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.secondary_total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.secondary_total_count * 100, 2);

      secondary_selected_adv_sos.push(p.sos);
      secondary_selected_adv_som.push(p.som);
      secondary_selected_adv_sof.push(p.sof);
      secondary_selected_adv_brandNames.push(p.brand);
    });

    this.secondary_selected_adv_sos = secondary_selected_adv_sos;
    this.secondary_selected_adv_som = secondary_selected_adv_som;
    this.secondary_selected_adv_sof = secondary_selected_adv_sof;
    this.secondary_selected_adv_brandNames = secondary_selected_adv_brandNames;

    this.secondary_aggregated_days.forEach(p => {

      p.sos = this.numberRound(p.net_spend / this.secondary_total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.secondary_total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.secondary_total_count * 100, 2);
    });

    this.secondary_aggregated_channels.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.secondary_total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.secondary_total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.secondary_total_count * 100, 2);
    });

    this.secondary_dataSource_adv_brands_tab = new MatTableDataSource(this.secondary_aggregated_brands);
    this.secondary_dataSource_adv_brands_days_tab = new MatTableDataSource(this.secondary_aggregated_days);

    this.secondary_dataSource_adv_channel_tab = new MatTableDataSource(this.secondary_aggregated_channels);


    this.secondary_aggregated_genre = this.groupBy(secondary_selected_advData, 'genre', 'net_spend', 'total_minutes', 'count');


    const secondary_genreWiseData_Spend = new Array();
    const secondary_genreWiseData_Names = new Array();
    const secondary_genreWiseData_SOS = new Array();


    this.secondary_aggregated_genre.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_genre.forEach(p => {
      secondary_genreWiseData_Spend.push(p.net_spend)
      secondary_genreWiseData_Names.push(p.genre)
      secondary_genreWiseData_SOS.push(this.numberRound(p.net_spend / this.secondary_total_spend * 100, 2))
    });

    this.secondary_genreWiseData_Spend = secondary_genreWiseData_Spend;
    this.secondary_genreWiseData_Names = secondary_genreWiseData_Names;
    this.secondary_genreWiseData_SOS = secondary_genreWiseData_SOS;


    this.secondary_aggregated_region = this.groupBy(secondary_selected_advData, 'region', 'net_spend', 'total_minutes', 'count');


    const secondary_regionWiseData_Spend = new Array();
    const secondary_regionWiseData_Names = new Array();
    const secondary_regionWiseData_SOS = new Array();

    this.secondary_aggregated_region.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.secondary_aggregated_region.forEach(p => {
      secondary_regionWiseData_Spend.push(p.net_spend)
      secondary_regionWiseData_Names.push(p.region)
      secondary_regionWiseData_SOS.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))
    });

    this.secondary_regionWiseData_Spend = secondary_regionWiseData_Spend;
    this.secondary_regionWiseData_Names = secondary_regionWiseData_Names;
    this.secondary_regionWiseData_SOS = secondary_regionWiseData_SOS;


    this.aggregated_dataByPositions.forEach(p => {
      if (this.secondary_selected_adv) {
        if (this.secondary_selected_adv && p.company === this.secondary_selected_adv) {
          secondary_selected_advDataByPositions.push(p)
        }
      } else {
        secondary_selected_advDataByPositions.push(p)
      }
    });

    const secondary_position_ByCompanyName = new Array();
    const secondary_position_ByCompanySpend = new Array();
    const secondary_position_ByCompanyMinutes = new Array();
    const secondary_position_ByCompanyCount = new Array();


    this.secondary_aggregated_positions = this.groupBy(secondary_selected_advDataByPositions, 'position', 'net_spend', 'total_minutes', 'count');

    this.position_ByCompanyName.forEach(p => {
      this.secondary_aggregated_positions.forEach(d => {
        if (d.position === p) {
          secondary_position_ByCompanyName.push(d.position);
          secondary_position_ByCompanySpend.push(d.net_spend);
          secondary_position_ByCompanyMinutes.push(d.total_minutes);
          secondary_position_ByCompanyCount.push(d.count);
        }
      });
    });

    this.secondary_position_ByCompanyName = secondary_position_ByCompanyName
    this.secondary_position_ByCompanySpend = secondary_position_ByCompanySpend
    this.secondary_position_ByCompanyMinutes = secondary_position_ByCompanyMinutes
    this.secondary_position_ByCompanyCount = secondary_position_ByCompanyCount


    if (this.secondary_total_spend === 0) {
      this.differenceSpend = 0
    } else {
      this.differenceSpend = (this.total_spend - this.secondary_total_spend) / this.secondary_total_spend;
    }

    if (this.differenceMinutes === 0) {
      this.differenceMinutes = 0
    } else {
      this.differenceMinutes = (this.total_minutes - this.secondary_total_minutes) / this.secondary_total_minutes;
    }

    if (this.differenceCount === 0) {
      this.differenceMinutes = 0
    } else {
      this.differenceCount = (this.total_count - this.secondary_total_count) / this.secondary_total_count;
    }

    this.charts();

  }

  advertisers() {

    if (this.seasonality_trend_chart) {
      this.seasonality_trend_chart.destroy();
      this.total_spend_chart.destroy();
      this.total_minutes_chart.destroy();
      this.total_count_chart.destroy();
      this.top_slots_chart.destroy();

      // if (this.slots_ByBrandchart) {
      //  console.log('ON PAGE')
      //   this.top_slots_chart.destroy();
      //   this.slots_ByBrandchart.destroy();
      //   this.slots_ByCategoryChart.destroy();
      //   this.slots_ByCompanyChart.destroy();
      // }

      // if (this.positions_ByBrandchart) {
      //   this.positions_ByBrandchart.destroy();
      //   this.positions_ByCompanyChart.destroy();
      //   this.positions_RegularVsPremium.destroy();
      //   this.positions_ByCategoryChart.destroy();
      // }



    }

    const selected_advData = new Array();
    const selected_advDataByChannels = new Array();
    const selected_advDataBySlots = new Array();
    const selected_adv_sos = new Array();
    const selected_adv_som = new Array();
    const selected_adv_sof = new Array();
    const selected_adv_brandNames = new Array();
    const list_bran_adv = new Array();
    const list_channelby_adv = new Array();
    const list_slots_adv = new Array();
    const list_positions_adv = new Array();
    const selected_advDataByPositions = new Array();

    const genreWiseData = new Array();

    const seasonality_spend = new Array();
    const seasonality_minutes = new Array();
    const seasonality_count = new Array();
    const seasonality_days = new Array();
    const seasonality_avgSpend = new Array();
    let sumCount;
    let sumMinutes;
    let sumSpend;
    let sumofArray;
    sumofArray = 0;
    sumCount = 0;
    sumMinutes = 0;
    sumSpend = 0;



    if (this.url === '/advertisers/slots') {
      this.aggregated_dataBySlots.forEach(p => {
        if (this.selected_adv) {
          if (this.selected_adv && p.company === this.selected_adv) {
            list_slots_adv.push(p);
            if (this.selected_adv_slot) {
              if (p.slot === this.selected_adv_slot) {
                selected_advDataBySlots.push(p);
                selected_advData.push(p);
              }
            } else {
              selected_advDataBySlots.push(p);
              selected_advData.push(p);
            }
          }
        } else {
          selected_advDataBySlots.push(p);
          selected_advData.push(p);
        }
      });
    } else {
      if (this.url === '/advertisers/positions') {
        this.aggregated_dataByPositions.forEach(p => {
          if (this.selected_adv) {
            if (this.selected_adv && p.company === this.selected_adv) {
              list_positions_adv.push(p);
              selected_advDataByPositions.push(p);
              selected_advData.push(p);
              // if (this.selected_adv_position) {
              //   if (p.position === this.selected_adv_position) {
              //     selected_advDataByPositions.push(p);
              //     // selected_advData.push(p);
              //   }
              // } else {
              //   selected_advDataByPositions.push(p);
              //   // selected_advData.push(p);
              // }
            }
          }
          else {
            selected_advDataByPositions.push(p);
            selected_advData.push(p);
          }
        });
      } else {

        this.aggregated_dataByBrands.forEach(p => {
          if (this.selected_adv) {
            // if (this.selected_adv && p.company === this.selected_adv) {
            if (p.company === this.selected_adv) {
              list_bran_adv.push(p);
              list_channelby_adv.push(p);

              if (this.selected_adv_brand || this.selected_adv_channel) {
                if (p.brand === this.selected_adv_brand || p.channel === this.selected_adv_channel) {
                  selected_advData.push(p);
                  selected_advDataByChannels.push(p);
                }
              } else {
                selected_advData.push(p);
                selected_advDataByChannels.push(p);
              }
            }
          }
          else {
            selected_advData.push(p);
            selected_advDataByChannels.push(p);
          }
        });

        this.aggregated_dataBySlots.forEach(p => {
          if (this.selected_adv) {
            if (this.selected_adv && p.company === this.selected_adv) {


              if (this.selected_adv_brand) {
                if (p.brand === this.selected_adv_brand) {
                  selected_advDataBySlots.push(p);
                }
              } else {
                selected_advDataBySlots.push(p);
              }
            }
          }
          else {
            selected_advDataBySlots.push(p);
          }
        });

      }
    }

    this.list_slots_adv = this.groupBy(list_slots_adv, 'slot', 'net_spend', 'total_minutes', 'count');
    this.list_positions_adv = this.groupBy(list_positions_adv, 'position', 'net_spend', 'total_minutes', 'count');

    this.list_positions_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    // For Channel Mix Tables and Aggregated Data for tables


    if (this.url !== '/home') {
      this.aggregated_days = this.groupBy(selected_advData, 'day', 'net_spend', 'total_minutes', 'count');
    }
    this.aggregated_brands = this.groupBy(selected_advData, 'brand', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categories = this.groupBy(selected_advData, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_channels = this.groupBy(selected_advDataByChannels, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_slots = this.groupBy(selected_advDataBySlots, 'slot', 'net_spend', 'total_minutes', 'count');
    this.list_brandby_adv = this.groupBy(list_bran_adv, 'brand', 'net_spend', 'total_minutes', 'count');
    this.list_channelby_adv = this.groupBy(list_channelby_adv, 'channel', 'net_spend', 'total_minutes', 'count');

    // Position

    // this.aggregated_dataByPositions.forEach(p => {
    //   if (this.selected_adv) {
    //     if (this.selected_adv && p.company === this.selected_adv) {
    //       selected_advData.push(p);
    //       selected_advDataByPositions.push(p);
    //     }
    //   } else {
    //     selected_advDataByPositions.push(p);
    //     selected_advData.push(p);
    //   }
    // });



    this.aggregated_positions = this.groupBy(selected_advDataByPositions, 'position', 'net_spend', 'total_minutes', 'count');



    // Position Ends

    var counts = selected_advData.reduce((p, c) => {
      var name = c.brand;
      if (!p.hasOwnProperty(name)) {
        p[name] = 0;
      }
      p[name]++;
      return p;
    }, {});

    var countsExtended = Object.keys(counts).map(k => {
      return { name: k, count: counts[k] };
    });

    this.countsExtended = countsExtended;

    this.aggregated_brands.forEach(p => {
      this.countsExtended.forEach(c => {
        if (p.brand == c.name) {
          p.activeDays_count = c.count;

        }
      });
    });


    this.list_channelby_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.list_brandby_adv.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_brands.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_channels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    // console.log('this.aggregated_days')
    // console.log(this.aggregated_days)


    this.aggregated_days.forEach(p => {
      sumSpend += p.net_spend;
      seasonality_spend.push(p.net_spend);
      sumMinutes += p.total_minutes;
      seasonality_minutes.push(p.total_minutes);
      sumCount += p.count;
      seasonality_count.push(p.count);
      seasonality_days.push(p.day);
    });
    this.total_spend = sumSpend;
    this.total_minutes = sumMinutes;
    this.total_count = sumCount;
    this.seasonality_spend = seasonality_spend;
    this.seasonality_minutes = seasonality_minutes;
    this.seasonality_count = seasonality_count;
    this.seasonality_days = seasonality_days;

    this.list_brandby_adv = this.list_brandby_adv;

    for (let i = 0; i < this.seasonality_spend.length; i++) {
      sumofArray += this.seasonality_spend[i];
    }

    this.averageSpendPerDay = sumofArray / this.seasonality_spend.length;

    for (let i = 0; i < this.seasonality_days.length; i++) {
      seasonality_avgSpend.push(this.averageSpendPerDay);
    }
    this.seasonality_avgSpend = seasonality_avgSpend;

    const arrMax = arr => Math.max(...arr);
    const arrMin = arr => Math.min(...arr);
    this.maxSpend_value = arrMax(this.seasonality_spend);
    this.minSpend_value = arrMin(this.seasonality_spend);

    const arrMax_index = this.seasonality_spend.indexOf(this.maxSpend_value);
    this.maxSpend_day = this.seasonality_days[arrMax_index];

    const arrMin_index = this.seasonality_spend.indexOf(this.minSpend_value);
    this.minSpend_day = this.seasonality_days[arrMin_index];

    const slots_name = new Array();
    const slots_value = new Array();
    const slots_sos = new Array();

    if (this.slots_name) {
      delete this.slots_name;
      delete this.slots_value;
    }
    this.aggregated_slots.forEach(p => {
      slots_name.push(p.slot);
      slots_value.push(p.net_spend);
      slots_sos.push(this.numberRound(((p.net_spend / this.total_spend) * 100), 2))
    });

    this.slots_name = slots_name;
    this.slots_value = slots_value;
    this.slots_sos = slots_sos;


    this.topBrand_Single = this.aggregated_brands[0];
    let sumForBrandAvg;
    sumForBrandAvg = 0;
    this.aggregated_brands.forEach(p => {
      sumForBrandAvg += p.net_spend;

    });

    this.averageSpendByBrands = sumForBrandAvg / this.aggregated_brands.length;

    this.lastBrand_Single = this.aggregated_brands.slice(-1)[0];


    if (this.total_spend == 0) {
      this.topBrandSOS = 0;
      this.lastBrandSOS = 0;
      this.alertMessage = this.selected_adv + ' is not active during the selected period.';


    } else {
      this.topBrandSOS = this.topBrand_Single.net_spend / this.total_spend * 100;
      this.lastBrandSOS = this.lastBrand_Single.net_spend / this.total_spend * 100;
      this.alertMessage = '';
    }



    this.aggregated_brands.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.total_count * 100, 2);

      selected_adv_sos.push(p.sos);
      selected_adv_som.push(p.som);
      selected_adv_sof.push(p.sof);
      selected_adv_brandNames.push(p.brand);
    });

    this.selected_adv_sos = selected_adv_sos;
    this.selected_adv_som = selected_adv_som;
    this.selected_adv_sof = selected_adv_sof;
    this.selected_adv_brandNames = selected_adv_brandNames;

    this.aggregated_days.forEach(p => {

      p.sos = this.numberRound(p.net_spend / this.total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.total_count * 100, 2);
    });

    this.aggregated_channels.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.total_count * 100, 2);
    });

    this.dataSource_adv_brands_tab = new MatTableDataSource(this.aggregated_brands);
    this.dataSource_adv_brands_days_tab = new MatTableDataSource(this.aggregated_days);
    this.dataSource_adv_channel_tab = new MatTableDataSource(this.aggregated_channels);


    // console.log('this.aggregated_channels');
    // console.log(this.aggregated_channels);

    this.grouped_Slots = this.groupByField(selected_advDataBySlots, 'brand', 'slot');



    this.groupedSlots = this.groupByMain(this.grouped_Slots, 'brand', 'brandId', 'slots');

    const slot_chart_brandName_arr = new Array();
    const slot_chart_morning_arr = new Array();
    const slot_chart_matinee_arr = new Array();
    const slot_chart_prePrime_arr = new Array();
    const slot_chart_prime_arr = new Array();
    const slot_chart_postPrime_arr = new Array();
    const slot_chart_lateNight_arr = new Array();

    this.groupedSlots.forEach(p => {
      let sumforBrandTotal;
      sumforBrandTotal = 0;
      p.slots.forEach(s => {
        sumforBrandTotal += s.net_spend;
        p.net_spend = sumforBrandTotal;
      });

    });

    this.groupedSlots.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });



    this.groupedSlots.forEach(p => {
      slot_chart_brandName_arr.push(p.brandId);
      p.slots.forEach(s => {
        // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
        if (p.net_spend === 0) {
          s.percent = 0;
        } else {
          s.percent = this.numberRound(s.net_spend / p.net_spend * 100, 2)
        }
        if (s.slot === 'MORNING') {
          slot_chart_morning_arr.push(s.percent);
        };
        if (s.slot === 'MATINEE') {
          slot_chart_matinee_arr.push(s.percent);
        };
        if (s.slot === 'PRE PRIME') {
          slot_chart_prePrime_arr.push(s.percent);
        };
        if (s.slot === 'PRIME') {
          slot_chart_prime_arr.push(s.percent);
        };
        if (s.slot === 'POST PRIME') {
          slot_chart_postPrime_arr.push(s.percent);
        };
        if (s.slot === 'LATE NIGHT') {
          slot_chart_lateNight_arr.push(s.percent);
        };
      });
    });

    this.slot_chart_brandName_arr = slot_chart_brandName_arr.slice(0, 10);
    this.slot_chart_morning_arr = slot_chart_morning_arr.slice(0, 10);
    this.slot_chart_matinee_arr = slot_chart_matinee_arr.slice(0, 10);
    this.slot_chart_prePrime_arr = slot_chart_prePrime_arr.slice(0, 10);
    this.slot_chart_prime_arr = slot_chart_prime_arr.slice(0, 10);
    this.slot_chart_postPrime_arr = slot_chart_postPrime_arr.slice(0, 10);
    this.slot_chart_lateNight_arr = slot_chart_lateNight_arr.slice(0, 10);


    // Slots (Boxes)
    if (this.url === '/advertisers/slots') {
      this.aggregated_slots.sort(function (a, b) {
        return b.net_spend - a.net_spend;
      });

      this.topSlot_Single = this.aggregated_slots[0];
      let sumForSlotAvg;
      sumForSlotAvg = 0;
      this.aggregated_slots.forEach(p => {
        sumForSlotAvg += p.net_spend;
      });

      this.averageSpendBySlots = sumForSlotAvg / this.aggregated_slots.length;

      this.lastSlot_Single = this.aggregated_slots.slice(-1)[0];

      if (this.total_spend == 0) {
        this.topSlotSOS = 0;
        this.lastSlotSOS = 0;
      } else {
        this.topSlotSOS = this.topSlot_Single.net_spend / this.total_spend * 100;
        this.lastSlotSOS = this.lastSlot_Single.net_spend / this.total_spend * 100;
      }
    }



    // Positions (Boxes)
    this.aggregated_positions.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    if (this.url === '/publishers/advertisers' || this.url === '/advertisers/positions') {


      this.aggregated_positions.forEach(p => {
        if (p.position === 'REGULAR SPOT') {
          this.regularSpotSpend = p.net_spend;

        }
      });

      this.premiumSpotSpend = this.total_spend - this.regularSpotSpend


      this.premiumSpotSpend = this.total_spend - this.regularSpotSpend;
      const premiumVsRegular_arr = new Array();
      premiumVsRegular_arr.push(this.regularSpotSpend);
      premiumVsRegular_arr.push(this.premiumSpotSpend);
      this.premiumVsRegular_arr = premiumVsRegular_arr;

    }







    if (this.url === '/advertisers/positions') {

      this.topPosition_Single = this.aggregated_positions[0];
      let sumForPositionAvg;
      sumForPositionAvg = 0;
      this.aggregated_positions.forEach(p => {
        sumForPositionAvg += p.net_spend;

      });

      this.averageSpendByPositions = sumForPositionAvg / this.aggregated_positions.length;


      this.lastPosition_Single = this.aggregated_positions.slice(-1)[0];

      if (this.total_spend == 0) {
        this.topPositionSOS = 0;
        this.lastPositionSOS = 0;


      } else {
        this.topPositionSOS = this.topPosition_Single.net_spend / this.total_spend * 100;
        this.lastPositionSOS = this.lastPosition_Single.net_spend / this.total_spend * 100;
      }



      // Position By Brands Chart

      this.grouped_Positions = this.groupByField_Position(selected_advDataByPositions, 'brand', 'position');

      this.groupedPositions = this.groupByMain(this.grouped_Positions, 'brand', 'brandId', 'positions');


      const position_chart_brandName_arr = new Array();
      const position_chart_first_arr = new Array();
      const position_chart_second_arr = new Array();
      const position_chart_regular_arr = new Array();
      const position_chart_secondLast_arr = new Array();
      const position_chart_last_arr = new Array();
      const position_chart_island_arr = new Array();




      this.groupedPositions.forEach(p => {
        let sumforBrandTotal;
        sumforBrandTotal = 0;
        p.positions.forEach(s => {
          sumforBrandTotal += s.net_spend;
          p.net_spend = sumforBrandTotal;
        });

      });

      this.groupedPositions.sort(function (a, b) {
        return b.net_spend - a.net_spend;
      });

      let sumReg;
      sumReg = 0;


      this.groupedPositions.forEach(p => {
        position_chart_brandName_arr.push(p.brandId);
        p.positions.forEach(s => {
          // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
          if (p.net_spend === 0) {
            s.percent = 0;
          } else {
            s.percent = this.numberRound(s.net_spend / p.net_spend * 100, 2)
          }
          if (s.position === 'REGULAR SPOT') {
            position_chart_regular_arr.push(s.percent);
            sumReg += s.net_spend;
          };
          if (s.position === '1ST SPOT') {
            position_chart_first_arr.push(s.percent);
          };
          if (s.position === '2ND SPOT') {
            position_chart_second_arr.push(s.percent);
          };
          if (s.position === 'LAST SPOT') {
            position_chart_last_arr.push(s.percent);
          };
          if (s.position === '2ND LAST SPOT') {
            position_chart_secondLast_arr.push(s.percent);
          };
          if (s.position === 'ISLAND') {
            position_chart_island_arr.push(s.percent);
          };
        });
      });
      this.regularSpotSpend = sumReg;


      this.position_chart_brandName_arr = position_chart_brandName_arr.slice(0, 10);
      this.position_chart_first_arr = position_chart_first_arr.slice(0, 10);
      this.position_chart_second_arr = position_chart_second_arr.slice(0, 10);
      this.position_chart_regular_arr = position_chart_regular_arr.slice(0, 10);
      this.position_chart_secondLast_arr = position_chart_secondLast_arr.slice(0, 10);
      this.position_chart_last_arr = position_chart_last_arr.slice(0, 10);
      this.position_chart_island_arr = position_chart_island_arr.slice(0, 10);


    }

    this.premiumSpotSpend = this.total_spend - this.regularSpotSpend;
    const premiumVsRegular_arr = new Array();
    premiumVsRegular_arr.push(this.regularSpotSpend);
    premiumVsRegular_arr.push(this.premiumSpotSpend);
    this.premiumVsRegular_arr = premiumVsRegular_arr;

    /////////////////////////////




    this.selected_advData = selected_advData;


    this.compare_category_array = new Array();
    this.compare_brand_array = new Array();


    this.aggregated_dataByBrands_Complete.forEach(p => {
      if (this.selected_toCompare_category) {
        if (this.selected_toCompare_category === p.category) {
          this.compare_category_array.push(p)
        }
      } else {
        this.compare_category_array.push(p)

      }

    });

    // console.log('this.compare_category_array');
    // console.log(this.compare_category_array);


    this.aggregated_dataByBrands_Complete.forEach(p => {
      if (this.selected_toCompare_brand) {
        if (this.selected_toCompare_brand === p.brand) {
          this.compare_brand_array.push(p)
        }
      } else {
        this.compare_brand_array.push(p)

      }

    });


    // console.log('this.compare_brand_array')
    // console.log(this.compare_brand_array)



    // For Channel Mix Tables and Aggregated Data for tables



    this.aggregated_categoryToCompare_Bydays = this.groupBy(this.compare_category_array, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categoryToCompare_Bybrands = this.groupBy(this.compare_category_array, 'brand', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categoryToCompare_Bycategories = this.groupBy(this.compare_category_array, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categoryToCompare_Bychannels = this.groupBy(this.compare_category_array, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categoryToCompare_Bygenre = this.groupBy(this.compare_category_array, 'genre', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categoryToCompare_Byslots = this.groupBy(this.compare_category_array, 'slot', 'net_spend', 'total_minutes', 'count');



    this.aggregated_categoryToCompare_Bychannels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    // For Adv Channel Page (Category Wise genre Graph)

    this.aggregated_categoryToCompare_Bygenre.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    const genre_cat_values = new Array();
    const genre_cat_names = new Array();
    const genre_cat_sos = new Array();

    this.aggregated_categoryToCompare_Bygenre.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    let cat_totalSpend;
    cat_totalSpend = 0;
    this.aggregated_categoryToCompare_Bygenre.forEach(p => {
      cat_totalSpend += p.net_spend
    });

    this.categoryTotalSpend = cat_totalSpend;


    this.aggregated_categoryToCompare_Bygenre.forEach(p => {
      genre_cat_values.push(p.net_spend)
      genre_cat_names.push(p.genre)
      genre_cat_sos.push(this.numberRound(p.net_spend / this.categoryTotalSpend * 100, 2))
    });

    this.genre_cat_values = genre_cat_values;
    this.genre_cat_names = genre_cat_names;
    this.genre_cat_sos = genre_cat_sos;



    let categoryTotalSpend;
    let categoryTotalMinutes;
    let categoryTotalCount;

    categoryTotalSpend = 0;
    categoryTotalMinutes = 0;
    categoryTotalCount = 0;

    this.aggregated_categoryToCompare_Bychannels.forEach(p => {
      categoryTotalSpend += p.net_spend;
      categoryTotalMinutes += p.total_minutes;
      categoryTotalCount += p.count;
    });

    this.aggregated_categoryToCompare_Bychannels_spend = categoryTotalSpend;
    this.aggregated_categoryToCompare_Bychannels_minutes = categoryTotalMinutes;
    this.aggregated_categoryToCompare_Bychannels_frequency = categoryTotalCount;



    this.aggregated_categoryToCompare_Bychannels.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.aggregated_categoryToCompare_Bychannels_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.aggregated_categoryToCompare_Bychannels_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.aggregated_categoryToCompare_Bychannels_frequency * 100, 2);
    });


    this.aggregated_brandToCompare_Bydays = this.groupBy(this.compare_brand_array, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brandToCompare_Bybrands = this.groupBy(this.compare_brand_array, 'brand', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brandToCompare_Bycategories = this.groupBy(this.compare_brand_array, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brandToCompare_Bychannels = this.groupBy(this.compare_brand_array, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brandToCompare_Byslots = this.groupBy(this.compare_brand_array, 'slot', 'net_spend', 'total_minutes', 'count');

    this.aggregated_brandToCompare_Bychannels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    //  console.log('this.aggregated_categoryToCompare_Bydays');
    //  console.log(this.aggregated_categoryToCompare_Bychannels);

    this.aggregated_brandToCompare_Bychannels.forEach(p => {
      p.sos = this.numberRound(p.net_spend / this.total_spend * 100, 2);
      p.som = this.numberRound(p.total_minutes / this.total_minutes * 100, 2);
      p.sof = this.numberRound(p.count / this.total_count * 100, 2);
    });




    // Positions Page

    // For Advertisers Chart

    this.grouped_Positions_ByCompany = this.groupByField_Position_Company(selected_advDataByPositions, 'company', 'position');

    this.groupedPositions_ByCompany = this.groupByMain(this.grouped_Positions_ByCompany, 'company', 'companyId', 'positions');


    this.groupedPositions_ByCompany.forEach(p => {
      let sumSpend;
      let sumMinutes;
      let sumCount;
      sumSpend = 0;
      sumMinutes = 0;
      sumCount = 0;

      p.positions.forEach(s => {
        sumSpend += s.net_spend;
        sumMinutes += s.total_minutes;
        sumCount += s.count;
        p.net_spend = sumSpend;
        p.total_minutes = sumMinutes;
        p.total_count = sumCount;
      });

    });

    this.groupedPositions_ByCompany.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    const position_ByCompanySpend = new Array();
    const position_ByCompanyName = new Array();
    const position_ByCompanyMinutes = new Array();
    const position_ByCompanyCount = new Array();


    this.groupedPositions_ByCompany.forEach(p => {
      p.positions.forEach(s => {
        // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
        if (p.net_spend === 0) {
          s.sos = 0;
        } else {
          s.sos = this.numberRound(s.net_spend / p.net_spend * 100, 2)
          s.som = this.numberRound(s.total_minutes / p.total_minutes * 100, 2)
          s.sof = this.numberRound(s.count / p.total_count * 100, 2)
        }

        if (this.selected_adv) {
          if (this.selected_adv === s.company && s.position === 'REGULAR SPOT') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.position === '1ST SPOT') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.position === '2ND SPOT') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.position === 'LAST SPOT') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.position === '2ND LAST SPOT') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.position === 'ISLAND') {
            position_ByCompanyName.push(s.position)
            position_ByCompanySpend.push(s.net_spend)
            position_ByCompanyMinutes.push(s.total_minutes)
            position_ByCompanyCount.push(s.count)
          }
        }
      });
    });




    if (!this.selected_adv) {
      this.aggregated_positions.forEach(p => {
        if (p.position === 'REGULAR SPOT') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
        if (p.position === '1ST SPOT') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
        if (p.position === '2ND SPOT') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
        if (p.position === 'LAST SPOT') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
        if (p.position === '2ND LAST SPOT') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
        if (p.position === 'ISLAND') {
          position_ByCompanyName.push(p.position)
          position_ByCompanySpend.push(p.net_spend)
          position_ByCompanyMinutes.push(p.total_minutes)
          position_ByCompanyCount.push(p.count)
        }
      });
    }

    this.position_ByCompanySpend = position_ByCompanySpend;
    this.position_ByCompanyName = position_ByCompanyName;
    this.position_ByCompanyMinutes = position_ByCompanyMinutes;
    this.position_ByCompanyCount = position_ByCompanyCount;

    //////////// FOr Category //////////////

    this.grouped_Positions_ByCategory = this.groupByField_Position_Category(this.aggregated_dataByPositions_Complete, 'category', 'position');

    this.groupedPositions_ByCategory = this.groupByMain(this.grouped_Positions_ByCategory, 'category', 'categoryId', 'positions');




    this.groupedPositions_ByCategory.forEach(p => {
      let sumSpend;
      let sumMinutes;
      let sumCount;
      sumSpend = 0;
      sumMinutes = 0;
      sumCount = 0;

      p.positions.forEach(s => {
        sumSpend += s.net_spend;
        sumMinutes += s.total_minutes;
        sumCount += s.count;
        p.net_spend = sumSpend;
        p.total_minutes = sumMinutes;
        p.total_count = sumCount;
      });

    });

    this.groupedPositions_ByCategory.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    const position_ByCategorySpend = new Array();
    const position_ByCategoryName = new Array();
    const position_ByCategoryMinutes = new Array();
    const position_ByCategoryCount = new Array();


    this.groupedPositions_ByCategory.forEach(p => {
      p.positions.forEach(s => {
        // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
        if (p.net_spend === 0) {
          s.sos = 0;
        } else {
          s.sos = this.numberRound(s.net_spend / p.net_spend * 100, 2)
          s.som = this.numberRound(s.total_minutes / p.total_minutes * 100, 2)
          s.sof = this.numberRound(s.count / p.total_count * 100, 2)
        }



        if (this.selected_toCompare_category) {
          if (this.selected_toCompare_category === s.category && s.position === 'REGULAR SPOT') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }

          if (this.selected_toCompare_category === s.category && s.position === '1ST SPOT') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.position === '2ND SPOT') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.position === 'LAST SPOT') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.position === '2ND LAST SPOT') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.position === 'ISLAND') {
            position_ByCategoryName.push(s.position)
            position_ByCategorySpend.push(s.net_spend)
            position_ByCategoryMinutes.push(s.total_minutes)
            position_ByCategoryCount.push(s.count)
          }
        }
      });
    });




    if (!this.selected_toCompare_category) {
      this.aggregated_positions.forEach(p => {
        if (p.position === 'REGULAR SPOT') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
        if (p.position === '1ST SPOT') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
        if (p.position === '2ND SPOT') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
        if (p.position === 'LAST SPOT') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
        if (p.position === '2ND LAST SPOT') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
        if (p.position === 'ISLAND') {
          position_ByCategoryName.push(p.position)
          position_ByCategorySpend.push(p.net_spend)
          position_ByCategoryMinutes.push(p.total_minutes)
          position_ByCategoryCount.push(p.count)
        }
      });
    }

    this.position_ByCategorySpend = position_ByCategorySpend;
    this.position_ByCategoryName = position_ByCategoryName;
    this.position_ByCategoryMinutes = position_ByCategoryMinutes;
    this.position_ByCategoryCount = position_ByCategoryCount;

    //////////////// Slots Page /////////////

    // For Advertisers Chart

    this.grouped_Slots_ByCompany = this.groupByField_Slots_Company(selected_advDataBySlots, 'company', 'position');

    this.groupedSlots_ByCompany = this.groupByMain(this.grouped_Slots_ByCompany, 'company', 'companyId', 'slots');





    this.groupedSlots_ByCompany.forEach(p => {
      let sumSpend;
      let sumMinutes;
      let sumCount;
      sumSpend = 0;
      sumMinutes = 0;
      sumCount = 0;

      p.slots.forEach(s => {
        sumSpend += s.net_spend;
        sumMinutes += s.total_minutes;
        sumCount += s.count;
        p.net_spend = sumSpend;
        p.total_minutes = sumMinutes;
        p.total_count = sumCount;
      });

    });

    this.groupedSlots_ByCompany.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    const slot_ByCompanySpend = new Array();
    const slot_ByCompanyName = new Array();
    const slot_ByCompanyMinutes = new Array();
    const slot_ByCompanyCount = new Array();




    this.groupedSlots_ByCompany.forEach(p => {
      p.slots.forEach(s => {
        // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
        if (p.net_spend === 0) {
          s.sos = 0;
        } else {
          s.sos = this.numberRound(s.net_spend / p.net_spend * 100, 2)
          s.som = this.numberRound(s.total_minutes / p.total_minutes * 100, 2)
          s.sof = this.numberRound(s.count / p.total_count * 100, 2)
        }

        if (this.selected_adv) {
          if (this.selected_adv === s.company && s.slot === 'PRIME') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.slot === 'LATE NIGHT') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.slot === 'PRE PRIME') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.slot === 'MORNING') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.slot === 'POST PRIME') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
          if (this.selected_adv === s.company && s.slot === 'MATINEE') {
            slot_ByCompanyName.push(s.slot)
            slot_ByCompanySpend.push(s.net_spend)
            slot_ByCompanyMinutes.push(s.total_minutes)
            slot_ByCompanyCount.push(s.count)
          }
        }
      });
    });



    if (!this.selected_adv) {
      this.aggregated_slots.forEach(p => {
        if (p.slot === 'MATINEE') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
        if (p.slot === 'PRIME') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
        if (p.slot === 'POST PRIME') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
        if (p.slot === 'MORNING') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
        if (p.slot === 'PRE PRIME') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
        if (p.slot === 'LATE NIGHT') {
          slot_ByCompanyName.push(p.slot)
          slot_ByCompanySpend.push(p.net_spend)
          slot_ByCompanyMinutes.push(p.total_minutes)
          slot_ByCompanyCount.push(p.count)
        }
      });
    }

    this.slot_ByCompanySpend = slot_ByCompanySpend;
    this.slot_ByCompanyName = slot_ByCompanyName;
    this.slot_ByCompanyMinutes = slot_ByCompanyMinutes;
    this.slot_ByCompanyCount = slot_ByCompanyCount;



    /////// Slots By Category ///////



    this.grouped_Slots_ByCategory = this.groupByField_Slots_Category(this.aggregated_dataBySlots_Complete, 'category', 'slot');

    this.groupedSlots_ByCategory = this.groupByMain(this.grouped_Slots_ByCategory, 'category', 'categoryId', 'slots');






    this.groupedSlots_ByCategory.forEach(p => {
      let sumSpendcat;
      let sumMinutescat;
      let sumCountcat;
      sumSpendcat = 0;
      sumMinutescat = 0;
      sumCountcat = 0;

      p.slots.forEach(s => {
        sumSpendcat += s.net_spend;
        sumMinutescat += s.total_minutes;
        sumCountcat += s.count;
        p.net_spend = sumSpendcat;
        p.total_minutes = sumMinutescat;
        p.total_count = sumCountcat;
      });

    });

    this.groupedSlots_ByCategory.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });




    const slot_ByCategorySpend = new Array();
    const slot_ByCategoryName = new Array();
    const slot_ByCategoryMinutes = new Array();
    const slot_ByCategoryCount = new Array();




    this.groupedSlots_ByCategory.forEach(p => {
      p.slots.forEach(s => {
        // s.percent = this.numberRound(s.net_spend/p.net_spend*100, 2) + '%';
        if (p.net_spend === 0) {
          s.sos = 0;
        } else {
          s.sos = this.numberRound(s.net_spend / p.net_spend * 100, 2)
          s.som = this.numberRound(s.total_minutes / p.total_minutes * 100, 2)
          s.sof = this.numberRound(s.count / p.total_count * 100, 2)
        }

        if (this.selected_toCompare_category) {
          if (this.selected_toCompare_category === s.category && s.slot === 'PRIME') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.slot === 'LATE NIGHT') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.slot === 'PRE PRIME') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.slot === 'MORNING') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.slot === 'POST PRIME') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
          if (this.selected_toCompare_category === s.category && s.slot === 'MATINEE') {
            slot_ByCategoryName.push(s.slot)
            slot_ByCategorySpend.push(s.net_spend)
            slot_ByCategoryMinutes.push(s.total_minutes)
            slot_ByCategoryCount.push(s.count)
          }
        }
      });
    });



    if (!this.selected_toCompare_category) {
      this.aggregated_slots.forEach(p => {
        if (p.slot === 'MATINEE') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
        if (p.slot === 'PRIME') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
        if (p.slot === 'POST PRIME') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
        if (p.slot === 'MORNING') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
        if (p.slot === 'PRE PRIME') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
        if (p.slot === 'LATE NIGHT') {
          slot_ByCategoryName.push(p.slot)
          slot_ByCategorySpend.push(p.net_spend)
          slot_ByCategoryMinutes.push(p.total_minutes)
          slot_ByCategoryCount.push(p.count)
        }
      });
    }

    this.slot_ByCategorySpend = slot_ByCategorySpend;
    this.slot_ByCategoryName = slot_ByCategoryName;
    this.slot_ByCategoryMinutes = slot_ByCategoryMinutes;
    this.slot_ByCategoryCount = slot_ByCategoryCount;



    //////////////// Slots Page End ////////

    //////////////// Genre Charts ////////


    this.aggregated_genre = this.groupBy(this.selected_advData, 'genre', 'net_spend', 'total_minutes', 'count');


    const genreWiseData_Spend = new Array();
    const genreWiseData_Names = new Array();
    const genreWiseData_SOS = new Array();


    this.aggregated_genre.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_genre.forEach(p => {
      genreWiseData_Spend.push(p.net_spend)
      genreWiseData_Names.push(p.genre)
      genreWiseData_SOS.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))
    });

    this.genreWiseData_Spend = genreWiseData_Spend;
    this.genreWiseData_Names = genreWiseData_Names;
    this.genreWiseData_SOS = genreWiseData_SOS;


    this.aggregated_region = this.groupBy(this.selected_advData, 'region', 'net_spend', 'total_minutes', 'count');


    const regionWiseData_Spend = new Array();
    const regionWiseData_Names = new Array();
    const regionWiseData_SOS = new Array();

    this.aggregated_region.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    this.aggregated_region.forEach(p => {
      regionWiseData_Spend.push(p.net_spend)
      regionWiseData_Names.push(p.region)
      regionWiseData_SOS.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))
    });

    this.regionWiseData_Spend = regionWiseData_Spend;
    this.regionWiseData_Names = regionWiseData_Names;
    this.regionWiseData_SOS = regionWiseData_SOS;

    // Channel Type ///


    this.aggregated_channelType = this.groupBy(selected_advData, 'channel_type', 'net_spend', 'total_minutes', 'count');

    const channelType_cat_values = new Array();
    const channelType_cat_names = new Array();
    const channelType_cat_sos = new Array();


    this.aggregated_channelType.forEach(p => {
      channelType_cat_values.push(p.net_spend);
      channelType_cat_names.push(p.channel_type);
      channelType_cat_sos.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))

    });

    this.channelType_cat_values = channelType_cat_values;
    this.channelType_cat_names = channelType_cat_names;
    this.channelType_cat_sos = channelType_cat_sos;


    // this.selected_toCompare_category

    //////////////// Genre Charts End ////////






    this.charts();
    this.dataAvailable = true;





    // this.charts();

  }


  async getCategoryTable_forChannelPage() {
    this.dataSource_categoryToCompare_Bychannels = await new MatTableDataSource(this.aggregated_categoryToCompare_Bychannels);

  }

  async getBrandTable_forChannelPage() {
    this.dataSource_brandToCompare_Bychannels = await new MatTableDataSource(this.aggregated_brandToCompare_Bychannels);
  }

  async getAdvertisersTable_forChannelPage() {
    this.dataSource_adv_channel_tab = await new MatTableDataSource(this.aggregated_channels);
  }




  categories() {



    if (this.seasonality_trend_chart) {
      this.seasonality_trend_chart.destroy();
      this.total_spend_chart.destroy();
      this.total_minutes_chart.destroy();
      this.total_count_chart.destroy();
      this.top_slots_chart.destroy();

      if (this.slots_ByBrandchart) {
        this.slots_ByBrandchart.destroy();
      }


    }


    const selected_advData = new Array();
    const selected_advDataByChannels = new Array();
    const selected_advDataBySlots = new Array();

    const seasonality_spend = new Array();
    const seasonality_minutes = new Array();
    const seasonality_count = new Array();
    const seasonality_days = new Array();
    const seasonality_avgSpend = new Array();
    let sumCount;
    let sumMinutes;
    let sumSpend;
    let sumofArray;
    sumofArray = 0;
    sumCount = 0;
    sumMinutes = 0;
    sumSpend = 0;

    this.aggregated_dataByBrands.forEach(p => {
      if (this.selected_cat) {
        if (this.selected_cat && p.category === this.selected_cat) {
          selected_advData.push(p);
        }
      } else {
        selected_advData.push(p);
      }
    });

    this.aggregated_dataByChannels.forEach(p => {
      if (this.selected_cat) {
        if (this.selected_cat && p.category === this.selected_cat) {
          selected_advDataByChannels.push(p);
        }
      } else {
        selected_advDataByChannels.push(p);
      }
    });

    this.aggregated_dataBySlots.forEach(p => {
      if (this.selected_cat) {
        if (this.selected_cat && p.category === this.selected_cat) {
          selected_advDataBySlots.push(p);
        }
      } else {
        selected_advDataBySlots.push(p);
      }
    });

    const selected_catDataByPositions = new Array();

    this.aggregated_dataByPositions.forEach(p => {
      if (this.selected_cat) {
        if (this.selected_cat && p.category === this.selected_cat) {
          selected_catDataByPositions.push(p);
        }
      } else {
        selected_catDataByPositions.push(p);
      }
    });



    this.aggregated_days = this.groupBy(selected_advData, 'day', 'net_spend', 'total_minutes', 'count');
    this.aggregated_brands = this.groupBy(selected_advData, 'brand', 'net_spend', 'total_minutes', 'count');
    this.aggregated_categories = this.groupBy(selected_advData, 'category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_sub_categories = this.groupBy(selected_advData, 'sub_category', 'net_spend', 'total_minutes', 'count');
    this.aggregated_companies = this.groupBy(selected_advData, 'company', 'net_spend', 'total_minutes', 'count');
    this.aggregated_channels = this.groupBy(selected_advDataByChannels, 'channel', 'net_spend', 'total_minutes', 'count');
    this.aggregated_slots = this.groupBy(selected_advDataBySlots, 'slot', 'net_spend', 'total_minutes', 'count');
    this.aggregated_genre = this.groupBy(selected_advDataByChannels, 'genre', 'net_spend', 'total_minutes', 'count');
    this.aggregated_channelType = this.groupBy(selected_advDataByChannels, 'channel_type', 'net_spend', 'total_minutes', 'count');




    this.aggregated_channelType.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_brands.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_genre.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_sub_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_companies.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });


    this.aggregated_categories.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });
    this.aggregated_channels.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });







    this.aggregated_days.forEach(p => {
      sumSpend += p.net_spend;
      seasonality_spend.push(p.net_spend);
      sumMinutes += p.total_minutes;
      seasonality_minutes.push(p.total_minutes);
      sumCount += p.count;
      seasonality_count.push(p.count);
      seasonality_days.push(p.day);
    });
    this.total_spend = sumSpend;
    this.total_minutes = sumMinutes;
    this.total_count = sumCount;
    this.seasonality_spend = seasonality_spend;
    this.seasonality_minutes = seasonality_minutes;
    this.seasonality_count = seasonality_count;
    this.seasonality_days = seasonality_days;

    for (let i = 0; i < this.seasonality_spend.length; i++) {
      sumofArray += this.seasonality_spend[i];
    }

    this.averageSpendPerDay = sumofArray / this.seasonality_spend.length;

    for (let i = 0; i < this.seasonality_days.length; i++) {
      seasonality_avgSpend.push(this.averageSpendPerDay);
    }
    this.seasonality_avgSpend = seasonality_avgSpend;

    const arrMax = arr => Math.max(...arr);
    const arrMin = arr => Math.min(...arr);
    this.maxSpend_value = arrMax(this.seasonality_spend);
    this.minSpend_value = arrMin(this.seasonality_spend);

    const arrMax_index = this.seasonality_spend.indexOf(this.maxSpend_value);
    this.maxSpend_day = this.seasonality_days[arrMax_index];

    const arrMin_index = this.seasonality_spend.indexOf(this.minSpend_value);
    this.minSpend_day = this.seasonality_days[arrMin_index];

    const slots_name = new Array();
    const slots_value = new Array();
    const slots_sos = new Array();

    this.aggregated_slots.forEach(p => {
      slots_name.push(p.slot);
      slots_value.push(p.net_spend);
      slots_sos.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))
    });

    this.slots_name = slots_name;
    this.slots_value = slots_value;
    this.slots_sos = slots_sos;

    const channels_name = new Array();
    const channels_value = new Array();

    this.aggregated_channels.forEach(element => {
      channels_name.push(element.channel);
      channels_value.push(element.net_spend);
    });

    this.channels_name = channels_name;
    this.channels_value = channels_value;

    this.topBrand_Single = this.aggregated_brands[0];
    let sumForBrandAvg;
    sumForBrandAvg = 0;
    this.aggregated_brands.forEach(p => {
      sumForBrandAvg += p.net_spend;
    });

    this.averageSpendByBrands = sumForBrandAvg / this.aggregated_brands.length;


    this.lastBrand_Single = this.aggregated_brands.slice(-1)[0];


    if (this.total_spend == 0) {
      this.topBrandSOS = 0;
      this.lastBrandSOS = 0;
      this.alertMessage = this.selected_cat + ' is not active during the selected period.';
    }
    else {
      this.topBrandSOS = this.topBrand_Single.net_spend / this.total_spend * 100;
      this.lastBrandSOS = this.lastBrand_Single.net_spend / this.total_spend * 100;
      this.alertMessage = '';
    }

    // Position ///

    this.aggregated_positions_cat = this.groupBy(selected_catDataByPositions, 'position', 'net_spend', 'total_minutes', 'count');

    this.aggregated_positions_cat.sort(function (a, b) {
      return b.net_spend - a.net_spend;
    });

    const positions_cat_values = new Array();
    const positions_cat_names = new Array();
    const positions_cat_sos = new Array();


    this.aggregated_positions_cat.forEach(p => {
      positions_cat_values.push(p.net_spend);
      positions_cat_names.push(p.position);
      positions_cat_sos.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))

    });

    this.positions_cat_values = positions_cat_values;
    this.positions_cat_names = positions_cat_names;
    this.positions_cat_sos = positions_cat_sos;


    // Genre ///

    const genre_cat_values = new Array();
    const genre_cat_names = new Array();
    const genre_cat_sos = new Array();


    this.aggregated_genre.forEach(p => {
      genre_cat_values.push(p.net_spend);
      genre_cat_names.push(p.genre);
      genre_cat_sos.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))

    });

    this.genre_cat_values = genre_cat_values;
    this.genre_cat_names = genre_cat_names;
    this.genre_cat_sos = genre_cat_sos;


    // Channel Type ///

    const channelType_cat_values = new Array();
    const channelType_cat_names = new Array();
    const channelType_cat_sos = new Array();


    this.aggregated_channelType.forEach(p => {
      channelType_cat_values.push(p.net_spend);
      channelType_cat_names.push(p.channel_type);
      channelType_cat_sos.push(this.numberRound(p.net_spend / this.total_spend * 100, 2))

    });

    this.channelType_cat_values = channelType_cat_values;
    this.channelType_cat_names = channelType_cat_names;
    this.channelType_cat_sos = channelType_cat_sos;




    // this.dataSource_adv_brands_tab = new MatTableDataSource(this.aggregated_brands);

    this.charts();

    if (this.url === '/publishers/categories') {
      this.charts_PubCategories();
      this.charts_PubChannelType();
    }

    if (this.url === '/publishers/advertisers') {
      this.charts_PubChannelType();
    }


    this.dataAvailable = true;

  }


  groupBy(array, col, value1, value2, value3) {
    const r = [], o = {};
    array.forEach(function (a) {
      if (!o[a[col]]) {
        o[a[col]] = {};
        o[a[col]][col] = a[col];
        o[a[col]][value1] = 0;
        o[a[col]][value2] = 0;
        o[a[col]][value3] = 0;
        r.push(o[a[col]]);
      }
      o[a[col]][value1] += +a[value1];
      o[a[col]][value2] += +a[value2];
      o[a[col]][value3] += +a[value3];
    });
    return r;
  }

  numberRound(number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }

  groupByField(arr, brand, slot = '') {

    var brandArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      brandArr.map((ele) => {
        if (ele === item.brand) {
          pushed = true;
        }
      })
      if (!pushed) {
        brandArr.push(item.brand);
      }
    })

    brandArr.map((item) => {
      var sum = 0;
      arr.map((ele) => {
        if (ele.brand === item) {
          sum += parseFloat(ele.net_spend)
        }
      })
      resultArr.push({
        brand: item,
        net_spend: sum
      })
    })

    if (slot != '') {
      var resultArr = [];


      brandArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.slot) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.slot);
          }
        })

        stepArr.map((item1) => {
          var sum = 0;
          arr.map((ele) => {
            if (ele.slot === item1 && ele.brand === item) {
              sum += parseFloat(ele.net_spend)
            }
          })
          resultArr.push({
            brand: item,
            slot: item1,
            net_spend: sum
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }



  groupByField_Slots_Company(arr, company, slot = '') {

    var companyArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      companyArr.map((ele) => {
        if (ele === item.company) {
          pushed = true;
        }
      })
      if (!pushed) {
        companyArr.push(item.company);
      }
    })

    companyArr.map((item) => {
      var sumSpend = 0;
      var sumMinutes = 0;
      var sumCount = 0;
      arr.map((ele) => {
        if (ele.company === item) {
          sumSpend += parseFloat(ele.net_spend)
          sumMinutes += parseFloat(ele.total_minutes)
          sumCount += parseFloat(ele.count)
        }
      })
      resultArr.push({
        company: item,
        net_spend: sumSpend,
        total_minutes: sumMinutes,
        count: sumCount
      })
    })

    if (slot != '') {
      var resultArr = [];


      companyArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.slot) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.slot);
          }
        })

        stepArr.map((item1) => {
          var sumSpend = 0;
          var sumMinutes = 0;
          var sumCount = 0;
          arr.map((ele) => {
            if (ele.slot === item1 && ele.company === item) {
              sumSpend += parseFloat(ele.net_spend)
              sumMinutes += parseFloat(ele.total_minutes)
              sumCount += parseFloat(ele.count)
            }
          })
          resultArr.push({
            company: item,
            slot: item1,
            net_spend: sumSpend,
            total_minutes: sumMinutes,
            count: sumCount
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }

  groupByField_Slots_Category(arr, category, slot = '') {

    var categoryArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      categoryArr.map((ele) => {
        if (ele === item.category) {
          pushed = true;
        }
      })
      if (!pushed) {
        categoryArr.push(item.category);
      }
    })

    categoryArr.map((item) => {
      var sumSpend = 0;
      var sumMinutes = 0;
      var sumCount = 0;
      arr.map((ele) => {
        if (ele.category === item) {
          sumSpend += parseFloat(ele.net_spend)
          sumMinutes += parseFloat(ele.total_minutes)
          sumCount += parseFloat(ele.count)
        }
      })
      resultArr.push({
        category: item,
        net_spend: sumSpend,
        total_minutes: sumMinutes,
        count: sumCount
      })
    })

    if (slot != '') {
      var resultArr = [];


      categoryArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.slot) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.slot);
          }
        })

        stepArr.map((item1) => {
          var sumSpend = 0;
          var sumMinutes = 0;
          var sumCount = 0;
          arr.map((ele) => {
            if (ele.slot === item1 && ele.category === item) {
              sumSpend += parseFloat(ele.net_spend)
              sumMinutes += parseFloat(ele.total_minutes)
              sumCount += parseFloat(ele.count)
            }
          })
          resultArr.push({
            category: item,
            slot: item1,
            net_spend: sumSpend,
            total_minutes: sumMinutes,
            count: sumCount
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }

  groupByField_Position(arr, brand, position = '') {

    var brandArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      brandArr.map((ele) => {
        if (ele === item.brand) {
          pushed = true;
        }
      })
      if (!pushed) {
        brandArr.push(item.brand);
      }
    })

    brandArr.map((item) => {
      var sumSpend = 0;
      var sumMinutes = 0;
      var sumCount = 0;
      arr.map((ele) => {
        if (ele.brand === item) {
          sumSpend += parseFloat(ele.net_spend)
          sumMinutes += parseFloat(ele.total_minutes)
          sumCount += parseFloat(ele.count)
        }
      })
      resultArr.push({
        brand: item,
        net_spend: sumSpend,
        total_minutes: sumMinutes,
        count: sumCount
      })
    })

    if (position != '') {
      var resultArr = [];


      brandArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.position) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.position);
          }
        })

        stepArr.map((item1) => {
          var sumSpend = 0;
          var sumMinutes = 0;
          var sumCount = 0;
          arr.map((ele) => {
            if (ele.position === item1 && ele.brand === item) {
              sumSpend += parseFloat(ele.net_spend)
              sumMinutes += parseFloat(ele.total_minutes)
              sumCount += parseFloat(ele.count)
            }
          })
          resultArr.push({
            brand: item,
            position: item1,
            net_spend: sumSpend,
            total_minutes: sumMinutes,
            count: sumCount
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }

  groupByField_Position_Company(arr, company, position = '') {

    var companyArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      companyArr.map((ele) => {
        if (ele === item.company) {
          pushed = true;
        }
      })
      if (!pushed) {
        companyArr.push(item.company);
      }
    })

    companyArr.map((item) => {
      var sumSpend = 0;
      var sumMinutes = 0;
      var sumCount = 0;
      arr.map((ele) => {
        if (ele.company === item) {
          sumSpend += parseFloat(ele.net_spend)
          sumMinutes += parseFloat(ele.total_minutes)
          sumCount += parseFloat(ele.count)
        }
      })
      resultArr.push({
        company: item,
        net_spend: sumSpend,
        total_minutes: sumMinutes,
        count: sumCount
      })
    })

    if (position != '') {
      var resultArr = [];


      companyArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.position) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.position);
          }
        })

        stepArr.map((item1) => {
          var sumSpend = 0;
          var sumMinutes = 0;
          var sumCount = 0;
          arr.map((ele) => {
            if (ele.position === item1 && ele.company === item) {
              sumSpend += parseFloat(ele.net_spend)
              sumMinutes += parseFloat(ele.total_minutes)
              sumCount += parseFloat(ele.count)
            }
          })
          resultArr.push({
            company: item,
            position: item1,
            net_spend: sumSpend,
            total_minutes: sumMinutes,
            count: sumCount
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }

  groupByField_Position_Category(arr, category, position = '') {

    var categoryArr = [];
    var resultArr = [];

    arr.map((item) => {
      var pushed = false;
      categoryArr.map((ele) => {
        if (ele === item.category) {
          pushed = true;
        }
      })
      if (!pushed) {
        categoryArr.push(item.category);
      }
    })

    categoryArr.map((item) => {
      var sumSpend = 0;
      var sumMinutes = 0;
      var sumCount = 0;
      arr.map((ele) => {
        if (ele.category === item) {
          sumSpend += parseFloat(ele.net_spend)
          sumMinutes += parseFloat(ele.total_minutes)
          sumCount += parseFloat(ele.count)
        }
      })
      resultArr.push({
        category: item,
        net_spend: sumSpend,
        total_minutes: sumMinutes,
        count: sumCount
      })
    })

    if (position != '') {
      var resultArr = [];


      categoryArr.map((item) => {
        var stepArr = [];

        arr.map((item2) => {
          var pushed = false;
          stepArr.map((ele) => {
            if (ele === item2.position) {
              pushed = true;
            }
          })
          if (!pushed) {
            stepArr.push(item2.position);
          }
        })

        stepArr.map((item1) => {
          var sumSpend = 0;
          var sumMinutes = 0;
          var sumCount = 0;
          arr.map((ele) => {
            if (ele.position === item1 && ele.category === item) {
              sumSpend += parseFloat(ele.net_spend)
              sumMinutes += parseFloat(ele.total_minutes)
              sumCount += parseFloat(ele.count)
            }
          })
          resultArr.push({
            category: item,
            position: item1,
            net_spend: sumSpend,
            total_minutes: sumMinutes,
            count: sumCount
          })
        })

      })
      return resultArr;
    }
    return resultArr;
  }

  groupByMain(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
      .groupBy(fieldNameToGroupOn)
      .toPairs()
      .map(function (currentItem) {
        return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
      })
      .value();
    return result;
  }

  charts() {

    if (this.url === '/advertisers/channels') {
      this.charts_AdvGenreCompany();
      this.charts_AdvGenreCategory();
    } else if (this.url === '/advertisers/positions') {
      // Nothing
      this.charts_AdvPositions();
      this.charts_AdvPositions_Category();

    } else if (this.url === '/publishers/advertisers') {
      // Nothing
      this.charts_AdvPositions();
      this.charts_AdvPositions_Category();
      this.charts_AdvGenreCompany();
      this.charts_PubChannelType();

    } else if (this.url === '/advertisers/slots') {
      this.charts_AdvSlots();
      this.charts_AdvSlots_Category();
      this.charts_AdvSlotsCompany();



    } else {


      if (this.secondary_selected_adv_brand) {

        if (this.seasonality_trend_chart) {
          this.seasonality_trend_chart.destroy();
        }
        const ctx = document.getElementById('seasonality_trend_chart');
        this.seasonality_trend_chart = new Chart(ctx, {
          type: 'line',
          data: {
            datasets: [
              {
                label: 'Primary Brand',
                data: this.seasonality_spend,
                borderColor: 'rgba(38,193,177,1)',
                backgroundColor: 'rgba(38,193,177,1)',
                // fill: 'start',
                fill: false,

              },
              {
                label: 'Secondary Brand',
                data: this.secondary_seasonality_spend,
                borderColor: '#9B59B6',
                backgroundColor: '#9B59B6',
                // fill: 'start',
                fill: false,

              }
            ],
            labels: this.seasonality_days,
          },
          // options: []
        });

        const ctx1 = document.getElementById('total_spend_chart');
        this.total_spend_chart = new Chart(ctx1, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [
              {
                label: 'Primary Brand',
                data: this.seasonality_spend,
                backgroundColor: ['#278de678'],
                borderWidth: 1,
                fill: false,

                // fill: 'start',   // 0: fill to 'origin'
              },
              {
                label: 'Secondary Brand',
                data: this.secondary_seasonality_spend,
                backgroundColor: ['#9B59B6'],
                borderWidth: 1,
                fill: false,

                // fill: 'start',   // 0: fill to 'origin'
              }
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }],
              xAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }]
            },
            plugins: {
              filler: {
                propagate: true
              }
            }
          }
        });

        const ctx2 = document.getElementById('total_minutes_chart');
        this.total_minutes_chart = new Chart(ctx2, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [{
              label: 'Primary Brand',
              data: this.seasonality_minutes,
              backgroundColor: ['#278de678'],
              borderWidth: 1,
              fill: false,

              // fill: 'start',   // 0: fill to 'origin'
            },
            {
              label: 'Secondary Brand',
              data: this.secondary_seasonality_minutes,
              backgroundColor: ['#9B59B6'],
              borderWidth: 1,
              fill: false,

              // fill: 'start',   // 0: fill to 'origin'
            }
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }],
              xAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }]
            },
            plugins: {
              filler: {
                propagate: true
              }
            }
          }
        });


        const ctx3 = document.getElementById('total_count_chart');
        this.total_count_chart = new Chart(ctx3, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [
              {
                label: 'Primary Brand',
                data: this.seasonality_count,
                backgroundColor: ['#278de678'],
                borderWidth: 1,
                fill: false,

                // fill: 'start',   // 0: fill to 'origin'
              },
              {
                label: 'Secondary Brand',
                data: this.secondary_seasonality_count,
                backgroundColor: ['#9B59B6'],
                borderWidth: 1,
                fill: false,

                // fill: 'start',   // 0: fill to 'origin'
              }
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
              }],
              xAxes: [{
                display: false,
              }]
            },
            plugins: {
              filler: {
                propagate: false
              }
            }
          }
        });

      } else {
        const ctx = document.getElementById('seasonality_trend_chart');
        this.seasonality_trend_chart = new Chart(ctx, {
          type: 'line',
          data: {
            datasets: [{
              label: 'Avg Spend',
              data: this.seasonality_avgSpend,
              borderColor: '#278de6',
              backgroundColor: '#278de6',
              fill: false,
              type: 'line'
            },
            {
              label: 'Net Spend',
              data: this.seasonality_spend,
              borderColor: 'rgba(38,193,177,1)',
              backgroundColor: 'rgba(38,193,177,1)',
              // fill: 'start',
              fill: false,

            }],
            labels: this.seasonality_days,
          },
          // options: []
        });

        const ctx1 = document.getElementById('total_spend_chart');
        this.total_spend_chart = new Chart(ctx1, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [{
              label: 'Net Spend',
              data: this.seasonality_spend,
              backgroundColor: ['#278de678'],
              borderWidth: 1,
              fill: 'start',   // 0: fill to 'origin'
            }]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }],
              xAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }]
            },
            plugins: {
              filler: {
                propagate: true
              }
            }
          }
        });

        const ctx2 = document.getElementById('total_minutes_chart');
        this.total_minutes_chart = new Chart(ctx2, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [{
              label: 'Minutes',
              data: this.seasonality_minutes,
              backgroundColor: ['#278de678'],
              borderWidth: 1,
              fill: 'start',   // 0: fill to 'origin'
            }]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }],
              xAxes: [{
                display: false,
                gridLines: {
                  display: false
                }
              }]
            },
            plugins: {
              filler: {
                propagate: true
              }
            }
          }
        });


        const ctx3 = document.getElementById('total_count_chart');
        this.total_count_chart = new Chart(ctx3, {
          type: 'line',
          data: {
            labels: this.seasonality_days,
            datasets: [{
              label: 'Frequency',
              data: this.seasonality_count,
              backgroundColor: ['#278de678'],
              borderWidth: 1,
              fill: 'start',   // 0: fill to 'origin'
            }]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                display: false,
              }],
              xAxes: [{
                display: false,
              }]
            },
            plugins: {
              filler: {
                propagate: false
              }
            }
          }
        });

      }

      // Position AdvBrands Page

      if (this.url === '/advertisers/brands' || this.url === '/advertisers/positions') {
        if (this.secondary_selected_adv_brand) {
          if (this.positions_ByCompanyChart) {
            this.positions_ByCompanyChart.destroy();
          }
          var ctx7 = document.getElementById("positions_ByCompanyChart");
          this.positions_ByCompanyChart = new Chart(ctx7, {
            type: 'bar',
            data: {
              datasets: [
                {
                  label: 'Primary Brand',
                  data: this.position_ByCompanySpend,
                  borderColor: 'rgba(38,193,177,1)',
                  backgroundColor: 'rgba(38,193,177,1)',
                  // fill: 'start',
                  fill: false,

                },
                {
                  label: 'Secondary Brand',
                  data: this.secondary_position_ByCompanySpend,
                  borderColor: '#9B59B6',
                  backgroundColor: '#9B59B6',
                  // fill: 'start',
                  fill: false,

                }],
              labels: this.position_ByCompanyName,
            },
            options: [
              {
                options: {
                  legends: true,
                  responsive: true,
                  tooltips: {
                    callbacks: {
                      label: function (tooltipItem, data) {

                        var dataset = data.datasets[tooltipItem.datasetIndex];

                        var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                          return previousValue + currentValue;
                        });

                        var currentValue = dataset.data[tooltipItem.index];

                        var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                        return precentage + "%";
                      }
                    }
                  },
                  legendCallback: function (chart) {
                    var text = [];
                    text.push('<ul class="' + chart.id + '-legend">');

                    var data = chart.data;
                    var datasets = data.datasets;
                    var labels = data.labels;

                    if (datasets.length) {
                      for (var i = 0; i < datasets[0].data.length; ++i) {
                        text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                        if (labels[i]) {

                          // calculate percentage
                          var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                            return previousValue + currentValue;
                          });
                          var currentValue = datasets[0].data[i];
                          var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                          text.push(labels[i] + ' (' + precentage + '%)');
                        }
                        text.push('</li>');
                      }
                    }
                    text.push('</ul>');
                    return text.join('');
                  },
                }
              }
            ]
          });
        } else {

          if (this.positions_ByCompanyChart) {
            this.positions_ByCompanyChart.destroy();
          }

          var ctx7 = document.getElementById("positions_ByCompanyChart");
          this.positions_ByCompanyChart = new Chart(ctx7, {
            type: 'horizontalBar',
            data: {
              datasets: [
                {
                  label: 'Net Spend',
                  data: this.position_ByCompanySpend,
                  borderColor: 'rgba(38,193,177,1)',
                  backgroundColor: 'rgba(38,193,177,1)',
                  // fill: 'start',
                  fill: false,

                }],
              labels: this.position_ByCompanyName,
            },
            options: [
              {
                options: {
                  legends: true,
                  responsive: true,
                  tooltips: {
                    callbacks: {
                      label: function (tooltipItem, data) {

                        var dataset = data.datasets[tooltipItem.datasetIndex];

                        var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                          return previousValue + currentValue;
                        });

                        var currentValue = dataset.data[tooltipItem.index];

                        var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                        return precentage + "%";
                      }
                    }
                  },
                  legendCallback: function (chart) {
                    var text = [];
                    text.push('<ul class="' + chart.id + '-legend">');

                    var data = chart.data;
                    var datasets = data.datasets;
                    var labels = data.labels;

                    if (datasets.length) {
                      for (var i = 0; i < datasets[0].data.length; ++i) {
                        text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                        if (labels[i]) {

                          // calculate percentage
                          var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                            return previousValue + currentValue;
                          });
                          var currentValue = datasets[0].data[i];
                          var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                          text.push(labels[i] + ' (' + precentage + '%)');
                        }
                        text.push('</li>');
                      }
                    }
                    text.push('</ul>');
                    return text.join('');
                  },
                }
              }
            ]
          });
        }
      }

      if (this.url === '/advertisers/brands' || this.url === '/advertisers/positions' || this.url === '/advertisers/channels') {
        if (this.secondary_selected_adv_brand) {
          if (this.genre_ByCompanyChart) {
            this.genre_ByCompanyChart.destroy();
          }
          var ctx10 = document.getElementById("genre_ByCompanyChart");
          this.genre_ByCompanyChart = new Chart(ctx10, {
            type: 'bar',
            data: {
              datasets: [
                {
                  label: 'Primary Brand',
                  // data: this.genreWiseData_Spend,
                  data: this.genreWiseData_SOS,
                  borderColor: 'rgba(38,193,177,1)',
                  backgroundColor: 'rgba(38,193,177,1)',
                  // fill: 'start',
                  fill: false,

                },
                {
                  label: 'Secondary Brand',
                  // data: this.genreWiseData_Spend,
                  data: this.secondary_genreWiseData_SOS,
                  borderColor: '#9B59B6',
                  backgroundColor: '#9B59B6',
                  // fill: 'start',
                  fill: false,

                }
              ],
              labels: this.genreWiseData_Names,
            },
            options: {

              tooltips: {
                mode: 'index',
                intersect: false,
                callbacks: {
                  label: function (t, d) {
                    if (t.datasetIndex === 0) {
                      return t.yLabel + '%';
                    } else if (t.datasetIndex === 1) {
                      return t.yLabel + '%';
                    }
                  }
                }
              },
              scales: {

                yAxes: [{
                  ticks: {

                    min: 0,
                    // max: 100,
                    callback: function (value) { return value + "%" }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Percentage"
                  }
                }]
              }
            }
          });

        } else {
          if (this.genre_ByCompanyChart) {
            this.genre_ByCompanyChart.destroy();
          }

          var ctx10 = document.getElementById("genre_ByCompanyChart");
          this.genre_ByCompanyChart = new Chart(ctx10, {
            type: 'bar',
            data: {
              datasets: [
                {
                  label: 'Spend Share',
                  // data: this.genreWiseData_Spend,
                  data: this.genreWiseData_SOS,
                  borderColor: 'rgba(38,193,177,1)',
                  backgroundColor: 'rgba(38,193,177,1)',
                  // fill: 'start',
                  fill: false,

                }],
              labels: this.genreWiseData_Names,
            },
            options: {
              tooltips: {
                mode: 'label',
                callbacks: {
                  label: function (tooltipItem, data) {
                    return data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              },
              scales: {

                yAxes: [{
                  ticks: {

                    min: 0,
                    max: 100,
                    callback: function (value) { return value + "%" }
                  },
                  // scaleLabel: {
                  //    display: true,
                  //    labelString: "Percentage"
                  // }
                }]
              }
            }
          });

        }
      }

      if (this.secondary_selected_adv_brand) {

        if (this.top_slots_chart) {
          this.top_slots_chart.destroy();
        }
        const ctx4 = document.getElementById('top_slots_chart');
        this.top_slots_chart = new Chart(ctx4, {
          type: 'bar',
          data: {
            datasets: [
              {
                label: 'Primary Brand',
                data: this.slots_sos,
                borderColor: 'rgba(38,193,177,1)',
                backgroundColor: 'rgba(38,193,177,1)',
                // fill: 'start',
                fill: false,
              },
              {
                label: 'Secondary Brand',
                data: this.secondary_slots_sos,
                borderColor: '#9B59B6',
                backgroundColor: '#9B59B6',
                // fill: 'start',
                fill: false,
              }
            ],
            labels: this.slots_name,
          },
          options: {

            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (t, d) {
                  if (t.datasetIndex === 0) {
                    return t.yLabel + '%';
                  } else if (t.datasetIndex === 1) {
                    return t.yLabel + '%';
                  }
                }
              }
            },
            scales: {

              yAxes: [{
                ticks: {

                  min: 0,
                  // max: 100,
                  callback: function (value) { return value + "%" }
                },
                scaleLabel: {
                  display: true,
                  labelString: "Percentage"
                }
              }]
            }
          }
        });

      } else {


        if (this.top_slots_chart) {
          this.top_slots_chart.destroy();
        }

        const ctx4 = document.getElementById('top_slots_chart');
        this.top_slots_chart = new Chart(ctx4, {
          type: 'pie',
          data: {
            labels: this.slots_name,
            datasets: [{
              label: 'Slots',
              data: this.slots_sos,
              backgroundColor: ['#DC143C', '#9932CC', '#278de6', '#2F4F4F', '#228B22', '#DAA520'],
              borderWidth: 1,
            }]
          },
          options: {
            tooltips: {
              mode: 'label',
              callbacks: {
                label: function (tooltipItem, data) {
                  return data['datasets'][0]['data'][tooltipItem['index']] + '%';
                }
              }
            },
          }
        });

      }




    }


  }

  charts_AdvPositions() {

    if (this.url === '/advertisers/positions') {

      if (this.positions_ByBrandchart) {
        this.positions_ByBrandchart.destroy();
      }

      var ctx7 = document.getElementById("positions_ByBrandchart");
      this.positions_ByBrandchart = new Chart(ctx7, {
        type: 'horizontalBar',
        data: {
          labels: this.position_chart_brandName_arr,
          datasets: [
            {
              label: '1ST',
              backgroundColor: '#5DADE2',
              stack: 'Stack 0',
              data: this.position_chart_first_arr
            }, {
              label: '2ND',
              backgroundColor: '#5D6D7E',
              stack: 'Stack 0',
              data: this.position_chart_second_arr
            }, {
              label: 'ISLAND',
              backgroundColor: '#F7DC6F',
              stack: 'Stack 0',
              data: this.position_chart_island_arr
            },
            {
              label: '2ND LAST',
              backgroundColor: '#48C9B0',
              stack: 'Stack 0',
              data: this.position_chart_secondLast_arr
            },
            {
              label: 'LAST',
              backgroundColor: '#E74C3C',
              stack: 'Stack 0',
              data: this.position_chart_last_arr
            },
            {
              label: 'REGULAR',
              backgroundColor: '#BB8FCE',
              stack: 'Stack 0',
              data: this.position_chart_regular_arr
            }
          ]
        },
        options: {
          title: {
            display: true,
            text: 'Brand wise Positions Share (Spend)'
          },
          tooltips: {
            mode: 'index',
            intersect: false
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      });
    }


    if (this.url === '/advertisers/positions' || this.url === '/publishers/advertisers') {

      if (this.positions_ByCompanyChart) {
        this.positions_ByCompanyChart.destroy();
      }

      var ctx7 = document.getElementById("positions_ByCompanyChart");
      this.positions_ByCompanyChart = new Chart(ctx7, {
        type: 'horizontalBar',
        data: {
          datasets: [
            {
              label: 'Net Spend',
              data: this.position_ByCompanySpend,
              borderColor: 'rgba(38,193,177,1)',
              backgroundColor: 'rgba(38,193,177,1)',
              // fill: 'start',
              fill: false,

            }],
          labels: this.position_ByCompanyName,
        },
        options: [
          {
            options: {
              legends: true,
              responsive: true,
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {

                    var dataset = data.datasets[tooltipItem.datasetIndex];

                    var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                      return previousValue + currentValue;
                    });

                    var currentValue = dataset.data[tooltipItem.index];

                    var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                    return precentage + "%";
                  }
                }
              },
              legendCallback: function (chart) {
                var text = [];
                text.push('<ul class="' + chart.id + '-legend">');

                var data = chart.data;
                var datasets = data.datasets;
                var labels = data.labels;

                if (datasets.length) {
                  for (var i = 0; i < datasets[0].data.length; ++i) {
                    text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                    if (labels[i]) {

                      // calculate percentage
                      var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                      });
                      var currentValue = datasets[0].data[i];
                      var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                      text.push(labels[i] + ' (' + precentage + '%)');
                    }
                    text.push('</li>');
                  }
                }
                text.push('</ul>');
                return text.join('');
              },
            }
          }
        ]
      });


      if (this.positions_RegularVsPremium) {
        this.positions_RegularVsPremium.destroy();
      }

      var ctx10 = document.getElementById("positions_RegularVsPremium");
      this.positions_RegularVsPremium = new Chart(ctx10, {
        type: 'pie',
        data: {
          labels: ['Regular Spots', 'Premium Spots'],
          datasets: [{
            label: 'Slots',
            // data: [this.regularSpotSpend, this.premiumSpotSpend],
            data: this.premiumVsRegular_arr,
            backgroundColor: ['#DC143C', '#9932CC', '#278de6', '#2F4F4F', '#228B22', '#DAA520'],
            borderWidth: 1,
          }]
        },
        options: {
          legend: {
            display: true,
          },
        }
      });
    }




    if (this.url === '/advertisers/slots') {

      if (this.slots_ByBrandchart) {
        this.slots_ByBrandchart.destroy();
      }

      var ctx6 = document.getElementById("slots_ByBrandchart");
      this.slots_ByBrandchart = new Chart(ctx6, {
        type: 'horizontalBar',
        data: {
          labels: this.slot_chart_brandName_arr,
          datasets: [
            {
              label: 'MORNING',
              backgroundColor: '#5DADE2',
              stack: 'Stack 0',
              data: this.slot_chart_morning_arr
            }, {
              label: 'MATINEE',
              backgroundColor: '#5D6D7E',
              stack: 'Stack 0',
              data: this.slot_chart_matinee_arr
            }, {
              label: 'PRE PRIME',
              backgroundColor: '#F7DC6F',
              stack: 'Stack 0',
              data: this.slot_chart_prePrime_arr
            },
            {
              label: 'PRIME',
              backgroundColor: '#48C9B0',
              stack: 'Stack 0',
              data: this.slot_chart_prime_arr
            },
            {
              label: 'POST PRIME',
              backgroundColor: '#E74C3C',
              stack: 'Stack 0',
              data: this.slot_chart_postPrime_arr
            },
            {
              label: 'LATE NIGHT',
              backgroundColor: '#BB8FCE',
              stack: 'Stack 0',
              data: this.slot_chart_lateNight_arr
            }
          ]
        },
        options: {
          title: {
            display: true,
            text: 'Brand wise Slots Share'
          },
          tooltips: {
            mode: 'index',
            intersect: false
          },
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      });
    }



  }

  charts_AdvPositions_Category() {
    if (this.url === '/advertisers/positions') {

      if (this.positions_ByCategoryChart) {
        this.positions_ByCategoryChart.destroy();
      }

      var ctx7 = document.getElementById("positions_ByCategoryChart");
      this.positions_ByCategoryChart = new Chart(ctx7, {
        type: 'horizontalBar',
        data: {
          datasets: [
            {
              label: 'Net Spend',
              data: this.position_ByCategorySpend,
              borderColor: 'rgba(38,193,177,1)',
              backgroundColor: 'rgba(38,193,177,1)',
              // fill: 'start',
              fill: false,

            }],
          labels: this.position_ByCategoryName,
        },
        options: [
          {
            options: {
              legends: true,
              responsive: true,
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {

                    var dataset = data.datasets[tooltipItem.datasetIndex];

                    var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                      return previousValue + currentValue;
                    });

                    var currentValue = dataset.data[tooltipItem.index];

                    var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                    return precentage + "%";
                  }
                }
              },
              legendCallback: function (chart) {
                var text = [];
                text.push('<ul class="' + chart.id + '-legend">');

                var data = chart.data;
                var datasets = data.datasets;
                var labels = data.labels;

                if (datasets.length) {
                  for (var i = 0; i < datasets[0].data.length; ++i) {
                    text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                    if (labels[i]) {

                      // calculate percentage
                      var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                      });
                      var currentValue = datasets[0].data[i];
                      var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                      text.push(labels[i] + ' (' + precentage + '%)');
                    }
                    text.push('</li>');
                  }
                }
                text.push('</ul>');
                return text.join('');
              },
            }
          }
        ]
      });



    }

  }

  charts_AdvSlots() {

    if (this.slots_ByBrandchart) {
      this.slots_ByBrandchart.destroy();
    }

    var ctx5 = document.getElementById("slots_ByBrandchart");
    this.slots_ByBrandchart = new Chart(ctx5, {
      type: 'horizontalBar',
      data: {
        labels: this.slot_chart_brandName_arr,
        datasets: [
          {
            label: 'MORNING',
            backgroundColor: '#5DADE2',
            stack: 'Stack 0',
            data: this.slot_chart_morning_arr
          }, {
            label: 'MATINEE',
            backgroundColor: '#5D6D7E',
            stack: 'Stack 0',
            data: this.slot_chart_matinee_arr
          }, {
            label: 'PRE PRIME',
            backgroundColor: '#F7DC6F',
            stack: 'Stack 0',
            data: this.slot_chart_prePrime_arr
          },
          {
            label: 'PRIME',
            backgroundColor: '#48C9B0',
            stack: 'Stack 0',
            data: this.slot_chart_prime_arr
          },
          {
            label: 'POST PRIME',
            backgroundColor: '#E74C3C',
            stack: 'Stack 0',
            data: this.slot_chart_postPrime_arr
          },
          {
            label: 'LATE NIGHT',
            backgroundColor: '#BB8FCE',
            stack: 'Stack 0',
            data: this.slot_chart_lateNight_arr
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Brand wise Slots Share'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    });

    if (this.top_slots_chartforSlot) {
      this.top_slots_chartforSlot.destroy();
    }

    const ctx8 = document.getElementById('top_slots_chartforSlot');
    this.top_slots_chartforSlot = new Chart(ctx8, {
      type: 'pie',
      data: {
        labels: this.slots_name,
        datasets: [{
          label: 'Slots',
          data: this.slots_value,
          backgroundColor: ['#DC143C', '#9932CC', '#278de6', '#2F4F4F', '#228B22', '#DAA520'],
          borderWidth: 1,
        }]
      },
      options: {
        legend: {
          display: true,
        },
      }
    });
  }

  charts_AdvSlots_Category() {

    if (this.slots_ByCategoryChart) {
      this.slots_ByCategoryChart.destroy();
    }
    var ctx9 = document.getElementById("slots_ByCategoryChart");
    this.slots_ByCategoryChart = new Chart(ctx9, {
      type: 'horizontalBar',
      data: {
        datasets: [
          {
            label: 'Net Spend',
            data: this.slot_ByCategorySpend,
            borderColor: 'rgba(38,193,177,1)',
            backgroundColor: 'rgba(38,193,177,1)',
            // fill: 'start',
            fill: false,

          }],
        labels: this.slot_ByCategoryName,
      },
      options: [
        {
          options: {
            legends: true,
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {

                  var dataset = data.datasets[tooltipItem.datasetIndex];

                  var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });

                  var currentValue = dataset.data[tooltipItem.index];

                  var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                  return precentage + "%";
                }
              }
            },
            legendCallback: function (chart) {
              var text = [];
              text.push('<ul class="' + chart.id + '-legend">');

              var data = chart.data;
              var datasets = data.datasets;
              var labels = data.labels;

              if (datasets.length) {
                for (var i = 0; i < datasets[0].data.length; ++i) {
                  text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                  if (labels[i]) {

                    // calculate percentage
                    var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                      return previousValue + currentValue;
                    });
                    var currentValue = datasets[0].data[i];
                    var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                    text.push(labels[i] + ' (' + precentage + '%)');
                  }
                  text.push('</li>');
                }
              }
              text.push('</ul>');
              return text.join('');
            },
          }
        }
      ]
    });

  }

  charts_AdvSlotsCompany() {

    if (this.slots_ByCompanyChart) {
      this.slots_ByCompanyChart.destroy();
    }

    var ctx10 = document.getElementById("slots_ByCompanyChart");
    this.slots_ByCompanyChart = new Chart(ctx10, {
      type: 'horizontalBar',
      data: {
        datasets: [
          {
            label: 'Net Spend',
            data: this.slot_ByCompanySpend,
            borderColor: 'rgba(38,193,177,1)',
            backgroundColor: 'rgba(38,193,177,1)',
            // fill: 'start',
            fill: false,

          }],
        labels: this.slot_ByCompanyName,
      },
      options: [
        {
          options: {
            legends: true,
            responsive: true,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {

                  var dataset = data.datasets[tooltipItem.datasetIndex];

                  var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });

                  var currentValue = dataset.data[tooltipItem.index];

                  var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                  return precentage + "%";
                }
              }
            },
            legendCallback: function (chart) {
              var text = [];
              text.push('<ul class="' + chart.id + '-legend">');

              var data = chart.data;
              var datasets = data.datasets;
              var labels = data.labels;

              if (datasets.length) {
                for (var i = 0; i < datasets[0].data.length; ++i) {
                  text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
                  if (labels[i]) {

                    // calculate percentage
                    var total = datasets[0].data.reduce(function (previousValue, currentValue, currentIndex, array) {
                      return previousValue + currentValue;
                    });
                    var currentValue = datasets[0].data[i];
                    var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                    text.push(labels[i] + ' (' + precentage + '%)');
                  }
                  text.push('</li>');
                }
              }
              text.push('</ul>');
              return text.join('');
            },
          }
        }
      ]
    });
  }

  charts_AdvGenreCompany() {

    if (this.genre_ByCompanyChart) {
      this.genre_ByCompanyChart.destroy();
    }

    var ctx10 = document.getElementById("genre_ByCompanyChart");
    this.genre_ByCompanyChart = new Chart(ctx10, {
      type: 'horizontalBar',
      data: {
        datasets: [
          {
            label: 'Spend Share',
            // data: this.genreWiseData_Spend,
            data: this.genreWiseData_SOS,
            borderColor: 'rgba(38,193,177,1)',
            backgroundColor: 'rgba(38,193,177,1)',
            // fill: 'start',
            fill: false,

          }],
        labels: this.genreWiseData_Names,
      },
      options: {
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              return data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
        scales: {

          xAxes: [{
            ticks: {

              min: 0,
              max: 100,
              callback: function (value) { return value + "%" }
            },
            // scaleLabel: {
            //    display: true,
            //    labelString: "Percentage"
            // }
          }]
        }
      }
    });


    if (this.region_ByCompanyChart) {
      this.region_ByCompanyChart.destroy();
    }

    var ctx10 = document.getElementById("region_ByCompanyChart");
    this.region_ByCompanyChart = new Chart(ctx10, {
      type: 'bar',
      data: {
        datasets: [
          {
            label: 'Spend Share',
            // data: this.regionWiseData_Spend,
            data: this.regionWiseData_SOS,
            borderColor: 'rgba(38,193,177,1)',
            backgroundColor: 'rgba(38,193,177,1)',
            // fill: 'start',
            fill: false,

          }],
        labels: this.regionWiseData_Names,
      },
      options: {
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              return data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
        scales: {

          yAxes: [{
            ticks: {

              min: 0,
              max: 100,
              callback: function (value) { return value + "%" }
            },
            scaleLabel: {
              display: true,
              labelString: "Percentage"
            }
          }]
        }
      }
    });
  }


  charts_PubCategories() {

    if (this.url === '/publishers/categories') {
      if (this.positionMix_Chart) {
        this.positionMix_Chart.destroy();
        this.genreMix_Chart.destroy();
        this.channelTpye_Chart.destroy();
      }

      const ctx12 = document.getElementById('positionMix_Chart');
      this.positionMix_Chart = new Chart(ctx12, {
        type: 'horizontalBar',
        data: {
          datasets: [
            {
              label: 'Spend Share',
              data: this.positions_cat_sos,
              borderColor: '#278de678',
              backgroundColor: '#278de678',
              // fill: 'start',
              fill: false,
            }
          ],
          labels: this.positions_cat_names,
        },
        options: {

          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (t, d) {
                if (t.datasetIndex === 0) {
                  return t.xLabel + '%';
                } else if (t.datasetIndex === 1) {
                  return t.xLabel + '%';
                }
              }
            }
          },
          scales: {

            xAxes: [{
              ticks: {

                min: 0,
                // max: 100,
                callback: function (value) { return value + "%" }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }]
          }
        }
      });

      const ctx13 = document.getElementById('genreMix_Chart');


      this.genreMix_Chart = new Chart(ctx13, {
        type: 'horizontalBar',
        data: {
          datasets: [
            {
              label: 'Spend Share',
              data: this.genre_cat_sos,
              borderColor: '#278de678',
              backgroundColor: '#278de678',
              // fill: 'start',
              fill: false,

            }
          ],
          labels: this.genre_cat_names,
        },
        options: {

          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (t, d) {
                if (t.datasetIndex === 0) {
                  return t.xLabel + '%';
                } else if (t.datasetIndex === 1) {
                  return t.xLabel + '%';
                }
              }
            }
          },

          scales: {

            xAxes: [{
              ticks: {

                min: 0,
                // max: 100,
                callback: function (value) { return value + "%" }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }]
          }
        }
      });





    }


  }

  charts_PubChannelType() {


    if (this.channelTpye_Chart) {
      this.channelTpye_Chart.destroy();
    }


    const ctx14 = document.getElementById('channelTpye_Chart');
    this.channelTpye_Chart = new Chart(ctx14, {
      type: 'pie',
      data: {
        labels: this.channelType_cat_names,
        datasets: [{
          label: 'Slots',
          data: this.channelType_cat_sos,
          backgroundColor: ['#DC143C', '#9932CC', '#278de6', '#2F4F4F', '#228B22', '#DAA520'],
          borderWidth: 1,
        }]
      },
      options: {
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              return data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
      }
    });


  }


  charts_AdvGenreCategory() {

    if (this.genre_ByCategoryChart) {
      this.genre_ByCategoryChart.destroy();
    }
    var ctx15 = document.getElementById("genre_ByCategoryChart");
    this.genre_ByCategoryChart = new Chart(ctx15, {
      type: 'horizontalBar',
      data: {
        datasets: [
          {
            label: 'Spend Share',
            // data: this.genreWiseData_Spend,
            data: this.genre_cat_sos,
            borderColor: 'rgba(38,193,177,1)',
            backgroundColor: 'rgba(38,193,177,1)',
            // fill: 'start',
            fill: false,

          }],
        labels: this.genre_cat_names,
      },
      options: {
        tooltips: {
          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              return data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
        scales: {

          xAxes: [{
            ticks: {

              min: 0,
              // max: 100,
              callback: function (value) { return value + "%" }
            },
            // scaleLabel: {
            //    display: true,
            //    labelString: "Percentage"
            // }
          }]
        }
      }
    });


  }
}




// WEBPACK FOOTER //
// ./src/app/services/item.service.ts